'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var sdkCore = require('@cognite/sdk-core');
var fromPairs = _interopDefault(require('lodash/fromPairs'));
var toPairs = _interopDefault(require('lodash/toPairs'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var version="9.17.0";

// Copyright 2020 Cognite AS
var AssetMappings3DAPI = /** @class */ (function (_super) {
    __extends(AssetMappings3DAPI, _super);
    function AssetMappings3DAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [List 3D asset mappings](https://doc.cognitedata.com/api/v1/#operation/get3DMappings)
         *
         * ```js
         * const mappings3D = await client.assetMappings3D.list(3244265346345, 32423454353545);
         * ```
         */
        _this.list = function (modelId, revisionId, scope) {
            var path = _this.encodeUrl(modelId, revisionId);
            return _super.prototype.listEndpoint.call(_this, function (params) { return _this.get(path, { params: params }); }, scope);
        };
        /**
         * [Filter 3D asset mappings](https://docs.cognite.com/api/v1/#operation/filter3DAssetMappings)
         *
         * ```js
         * const mappings3D = await client.assetMappings3D.filter(3244265346345, 32423454353545, {
         *   filter: {
         *     treeIndexes: [1000, 1001, 1002]
         *   }
         * });
         * ```
         */
        _this.filter = function (modelId, revisionId, query) {
            var path = _this.encodeUrl(modelId, revisionId) + "/list";
            return _super.prototype.listEndpoint.call(_this, function (params) {
                return _this.post(path, { data: params });
            }, query);
        };
        /**
         * [Create 3D asset mappings](https://doc.cognitedata.com/api/v1/#operation/create3DMappings)
         *
         * ```js
         * const assetMappingsToCreate = [
         *  {
         *    nodeId: 8252999965991682,
         *    assetId: 4354399876978078
         *  },
         *  {
         *    nodeId: 9034285498543958,
         *    assetId: 1042345809544395
         *  }
         * ];
         * const mappings3D = await client.assetMappings3D.create(
         *  25432542356436,
         *  33485743958747,
         *  assetMappingsToCreate
         * );
         * ```
         */
        _this.create = function (modelId, revisionId, items) {
            var path = _this.encodeUrl(modelId, revisionId);
            return _super.prototype.createEndpoint.call(_this, items, path);
        };
        /**
         * [Delete a list of asset mappings](https://doc.cognitedata.com/api/v1/#operation/delete3DMappings)
         *
         * ```js
         * const assetMappingsToDelete = [
         *  {
         *    nodeId: 8252999965991682,
         *    assetId: 4354399876978078
         *  },
         *  {
         *    nodeId: 9034285498543958,
         *    assetId: 1042345809544395
         *  }
         * ];
         * await client.assetMappings3D.delete(8252999965991682, 4190022127342195, assetMappingsToDelete);
         * ```
         */
        _this.delete = function (modelId, revisionId, ids) {
            var path = _this.encodeUrl(modelId, revisionId) + "/delete";
            return _super.prototype.deleteEndpoint.call(_this, ids, undefined, path);
        };
        return _this;
    }
    AssetMappings3DAPI.prototype.encodeUrl = function (modelId, revisionId) {
        return this.url(modelId + "/revisions/" + revisionId + "/mappings");
    };
    return AssetMappings3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var Files3DAPI = /** @class */ (function (_super) {
    __extends(Files3DAPI, _super);
    function Files3DAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Retrieve a 3D file"](https://doc.cognitedata.com/api/v1/#operation/get3DFile)
         *
         * ```js
         * await client.files3D.retrieve(3744350296805509);
         * ```
         */
        _this.retrieve = function (fileId) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url("" + fileId);
                        return [4 /*yield*/, this.get(path, {
                                responseType: sdkCore.HttpResponseType.ArrayBuffer,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        return _this;
    }
    return Files3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var Models3DAPI = /** @class */ (function (_super) {
    __extends(Models3DAPI, _super);
    function Models3DAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create 3D models](https://doc.cognitedata.com/api/v1/#operation/create3DModels)
         *
         * ```js
         * const modelsToCreate = [
         *   { name: 'Model 0' },
         *   { name: 'Model 2' },
         * ];
         * const models3D = await client.models3D.create(modelsToCreate);
         * ```
         */
        _this.create = function (models) {
            return _super.prototype.createEndpoint.call(_this, models);
        };
        /**
         * [List 3D models](https://doc.cognitedata.com/api/v1/#operation/get3DModels)
         *
         * ```js
         * const models3D = await client.models3D.list({ published: true });
         * ```
         */
        _this.list = function (scope) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithGet, scope);
        };
        /**
         * [Retrieve a 3D model](https://doc.cognitedata.com/api/v1/#operation/get3DModel)
         *
         * ```js
         * await client.models3D.retrieve(3744350296805509);
         * ```
         */
        _this.retrieve = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url("" + id);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Update 3D models](https://doc.cognitedata.com/api/v1/#operation/update3DModels)
         *
         * ```js
         * const modelsToUpdate = [
         *   { id: 3744350296805509, update: { name: { set: 'Model 0 updated' }}},
         *   { id: 8163365893677939, update: { name: { set: 'Model 2 updated' }}},
         * ];
         * const models3D = await client.models3D.update(modelsToUpdate);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        /**
         * [Delete 3D models](https://doc.cognitedata.com/api/v1/#operation/delete3DModels)
         *
         * ```js
         * await client.models3D.delete([{ id: 3744350296805509 }, { id: 8163365893677939 }]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    Models3DAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime']);
    };
    return Models3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var Nodes3DAPI = /** @class */ (function (_super) {
    __extends(Nodes3DAPI, _super);
    function Nodes3DAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.retrieve = function (modelId, revisionId, ids) {
            var path = _this.url(modelId + "/revisions/" + revisionId + "/nodes/byids");
            return _super.prototype.retrieveEndpoint.call(_this, ids, {}, path);
        };
        return _this;
    }
    Nodes3DAPI.prototype.list = function (modelId, revisionId, scope) {
        var _this = this;
        var path = this.url(modelId + "/revisions/" + revisionId + "/nodes");
        return _super.prototype.listEndpoint.call(this, function (params) { return _this.get(path, { params: params }); }, scope);
    };
    Nodes3DAPI.prototype.filter = function (modelId, revisionId, scope) {
        var _this = this;
        var path = this.url(modelId + "/revisions/" + revisionId + "/nodes/list");
        return _super.prototype.listEndpoint.call(this, function (params) { return _this.post(path, { data: params }); }, scope);
    };
    Nodes3DAPI.prototype.listAncestors = function (modelId, revisionId, nodeId, scope) {
        var _this = this;
        var path = this.url(modelId + "/revisions/" + revisionId + "/nodes/" + nodeId + "/ancestors");
        return _super.prototype.listEndpoint.call(this, function (params) { return _this.get(path, { params: params }); }, scope);
    };
    return Nodes3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var Revisions3DAPI = /** @class */ (function (_super) {
    __extends(Revisions3DAPI, _super);
    function Revisions3DAPI(resourcePath, httpClient, map) {
        var _this = _super.call(this, resourcePath, httpClient, map) || this;
        /**
         * [Create 3D revisions](https://doc.cognitedata.com/api/v1/#operation/create3DRevisions)
         *
         * ```js
         * const revisions = await client.revisions3D.create(4234325345643654, [{ fileId: 8252999965991682 }, { fileId: 6305529564379596 }]);
         * ```
         */
        _this.create = function (modelId, items) {
            return _super.prototype.createEndpoint.call(_this, items, _this.url(modelId + "/revisions"));
        };
        /**
         * [List 3D revisions](https://doc.cognitedata.com/api/v1/#operation/get3DRevisions)
         *
         * ```js
         * const revisions3D = await client.revisions3D.list(324566546546346);
         * ```
         */
        _this.list = function (modelId, filter) {
            var path = _this.url(modelId + "/revisions");
            return _super.prototype.listEndpoint.call(_this, function (params) { return _this.get(path, { params: params }); }, filter);
        };
        /**
         * [Retrieve a 3D revision](https://doc.cognitedata.com/api/v1/#operation/get3DRevision)
         *
         * ```js
         * const revisions3D = await client.revisions3D.retrieve(8252999965991682, 4190022127342195)
         * ```
         */
        _this.retrieve = function (modelId, revisionId) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url(modelId + "/revisions/" + revisionId);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Update 3D revisions](https://doc.cognitedata.com/api/v1/#operation/update3DRevisions)
         *
         * ```js
         * const revisionsToUpdate = [{
         *  id: 6305529564379596,
         *  update: {
         *    rotation: {
         *      set: [1, 2, 3]
         *    },
         *    translation: {
         *      set: [4, 5, 6]
         *    },
         *    scale: {
         *      set: [0.5, 0.3, 0.2]
         *    }
         *  }
         * }];
         * const updated = await client.revisions3D.update(8252999965991682, revisionsToUpdate);
         * ```
         */
        _this.update = function (modelId, items) {
            var path = _this.url(modelId + "/revisions/update");
            return _super.prototype.updateEndpoint.call(_this, items, path);
        };
        /**
         * [Delete 3D revisions](https://doc.cognitedata.com/api/v1/#operation/delete3DRevisions)
         *
         * ```js
         * await client.revisions3D.delete(8252999965991682, [{ id: 4190022127342195 }]);
         * ```
         */
        _this.delete = function (modelId, ids) {
            var path = _this.url(modelId + "/revisions/delete");
            return _super.prototype.deleteEndpoint.call(_this, ids, undefined, path);
        };
        /**
         * [Update 3D revision thumbnail](https://docs.cognite.com/api/v1/#operation/updateThumbnail)
         *
         * ```js
         * await client.revisions3D.updateThumbnail(8252999965991682, 4190022127342195, 3243334242324);
         * ```
         */
        _this.updateThumbnail = function (modelId, revisionId, fileId) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url(modelId + "/revisions/" + revisionId + "/thumbnail");
                        return [4 /*yield*/, this.post(path, { data: { fileId: fileId } })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn({}, response)];
                }
            });
        }); };
        /**
         * [List 3D nodes](https://doc.cognitedata.com/api/v1/#operation/get3DNodes)
         *
         * ```js
         * const nodes3d = await client.revisions3D.list3DNodes(8252999965991682, 4190022127342195);
         * ```
         */
        _this.list3DNodes = function (modelId, revisionId, query) {
            return _this.nodes3DApi.list(modelId, revisionId, query);
        };
        /**
         * [Filter 3D nodes](https://docs.cognite.com/api/v1/#operation/filter3DNodes)
         *
         * ```js
         * const query = {
         *  filter: {
         *    properties: {
         *      Items: {
         *        Type: ["Cylinder"]
         *      }
         *    }
         *  },
         *  partition: "1/10"
         * };
         * const nodes3d = await client.revisions3D.filter3DNodes(8252999965991682, 4190022127342195, query);
         * ```
         */
        _this.filter3DNodes = function (modelId, revisionId, query) {
            return _this.nodes3DApi.filter(modelId, revisionId, query);
        };
        /**
         * [Get 3D nodes by ID](https://docs.cognite.com/api/v1/#operation/get3DNodesById)
         *
         * ```js
         * const nodes3d = await client.revisions3D.retrieve3DNodes(8252999965991682, 4190022127342195, [{id: 123}, {id: 456}]);
         * ```
         */
        _this.retrieve3DNodes = function (modelId, revisionId, ids) {
            return _this.nodes3DApi.retrieve(modelId, revisionId, ids);
        };
        /**
         * [List 3D ancestor nodes](https://doc.cognitedata.com/api/v1/#operation/get3DNodeAncestors)
         *
         * ```js
         * const nodes3d = await client.revisions3D.list3DNodeAncestors(8252999965991682, 4190022127342195, 572413075141081);
         * ```
         */
        _this.list3DNodeAncestors = function (modelId, revisionId, nodeId, query) {
            return _this.nodes3DApi.listAncestors(modelId, revisionId, nodeId, query);
        };
        _this.nodes3DApi = new Nodes3DAPI(resourcePath, httpClient, map);
        return _this;
    }
    /**
     * @hidden
     */
    Revisions3DAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime']);
    };
    return Revisions3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var RevealNodes3DAPI = /** @class */ (function (_super) {
    __extends(RevealNodes3DAPI, _super);
    function RevealNodes3DAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RevealNodes3DAPI.prototype.list = function (modelId, revisionId, scope) {
        var _this = this;
        var path = this.encodeUrl(modelId, revisionId);
        return _super.prototype.listEndpoint.call(this, function (params) { return _this.get(path, { params: params }); }, scope);
    };
    RevealNodes3DAPI.prototype.listAncestors = function (modelId, revisionId, nodeId, scope) {
        var _this = this;
        var path = this.encodeUrl(modelId, revisionId) + "/" + nodeId + "/ancestors";
        return _super.prototype.listEndpoint.call(this, function (params) { return _this.get(path, { params: params }); }, scope);
    };
    RevealNodes3DAPI.prototype.encodeUrl = function (modelId, revisionId) {
        return this.url("models/" + modelId + "/revisions/" + revisionId + "/nodes");
    };
    return RevealNodes3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var RevealRevisions3DAPI = /** @class */ (function (_super) {
    __extends(RevealRevisions3DAPI, _super);
    function RevealRevisions3DAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    RevealRevisions3DAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime']);
    };
    RevealRevisions3DAPI.prototype.retrieve = function (modelId, revisionId) {
        return __awaiter(this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url("models/" + modelId + "/revisions/" + revisionId);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        });
    };
    return RevealRevisions3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var RevealSectors3DAPI = /** @class */ (function (_super) {
    __extends(RevealSectors3DAPI, _super);
    function RevealSectors3DAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RevealSectors3DAPI.prototype.list = function (modelId, revisionId, scope) {
        var _this = this;
        var path = this.url("models/" + modelId + "/revisions/" + revisionId + "/sectors");
        return _super.prototype.listEndpoint.call(this, function (params) { return _this.get(path, { params: params }); }, scope);
    };
    return RevealSectors3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var UnrealRevisions3DAPI = /** @class */ (function (_super) {
    __extends(UnrealRevisions3DAPI, _super);
    function UnrealRevisions3DAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    UnrealRevisions3DAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime']);
    };
    UnrealRevisions3DAPI.prototype.retrieve = function (modelId, revisionId) {
        return __awaiter(this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url("models/" + modelId + "/revisions/" + revisionId);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        });
    };
    return UnrealRevisions3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var Viewer3DAPI = /** @class */ (function (_super) {
    __extends(Viewer3DAPI, _super);
    /** @hidden */
    function Viewer3DAPI(resourcePath, httpClient, map) {
        var _this = _super.call(this, resourcePath, httpClient, map) || this;
        /**
         * [Retrieve a 3D revision (Reveal)](https://doc.cognitedata.com/api/v1/#operation/getReveal3DRevision)
         *
         * ```js
         * const revisionReveal = await client.viewer3D.retrieveRevealRevision3D(294879032167592, 3247239473298342)
         * ```
         */
        _this.retrieveRevealRevision3D = function (modelId, revisionId) {
            return _this.revealRevisions3DAPI.retrieve(modelId, revisionId);
        };
        /**
         * [List 3D nodes (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DNodes)
         *
         * ```js
         * const nodes3dReveal = await client.viewer3D
         *  .listRevealNodes3D(8252999965991682, 4190022127342195)
         *  .autoPagingToArray();
         * ```
         */
        _this.listRevealNodes3D = function (modelId, revisionId, query) {
            return _this.revealNodes3DAPI.list(modelId, revisionId, query);
        };
        /**
         * [List 3D ancestor nodes (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DNodeAncestors)
         *
         * ```js
         * const ancestorsReveal = await client.viewer3D
         *  .listRevealNode3DAncestors(8252999965991682, 4190022127342195, 120982398890213)
         *  .autoPagingToArray();
         * ```
         */
        _this.listRevealNode3DAncestors = function (modelId, revisionId, nodeId, query) {
            return _this.revealNodes3DAPI.listAncestors(modelId, revisionId, nodeId, query);
        };
        /**
         * [List 3D sectors (Reveal)](https://doc.cognitedata.com/api/v1/#operation/revealGet3DSectors)
         *
         * ```js
         * const sectors3D = await client.viewer3D
         *  .listRevealSectors3D(8252999965991682, 4190022127342195, { limit: 10 })
         *  .autoPagingToArray();
         * ```
         */
        _this.listRevealSectors3D = function (modelId, revisionId, query) {
            return _this.revealSectors3DAPI.list(modelId, revisionId, query);
        };
        /**
         * [Retrieve a 3D revision (Unreal)](https://doc.cognitedata.com/api/v1/#operation/getUnreal3DRevision)
         *
         * ```js
         * const revisions3DUnreal = await client.viewer3D.retrieveUnrealRevision3D(8252999965991682, 4190022127342195);
         * ```
         */
        _this.retrieveUnrealRevision3D = function (modelId, revisionId) {
            return _this.unrealRevisions3DAPI.retrieve(modelId, revisionId);
        };
        var revealPath = resourcePath + "/reveal";
        var unrealPath = resourcePath + "/unreal";
        _this.revealRevisions3DAPI = new RevealRevisions3DAPI(revealPath, httpClient, map);
        _this.revealNodes3DAPI = new RevealNodes3DAPI(revealPath, httpClient, map);
        _this.revealSectors3DAPI = new RevealSectors3DAPI(revealPath, httpClient, map);
        _this.unrealRevisions3DAPI = new UnrealRevisions3DAPI(unrealPath, httpClient, map);
        return _this;
    }
    return Viewer3DAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
var AnnotationsAPI = /** @class */ (function (_super) {
    __extends(AnnotationsAPI, _super);
    function AnnotationsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create annotations](https://docs.cognite.com/api/playground/#operation/annotationsCreate)
         *
         * const data = {
         *   pageNumber: 7,
         *   textRegion: { xMin: 0, xMax: 0.1, yMin: 0, yMax: 0.2 },
         *   extractedText: 'i am your father',
         * };
         * const annotation = {
         *   annotatedResourceType: 'file' as const,
         *   annotatedResourceId: 1,
         *   annotationType: 'documents.ExtractedText',
         *   creatingApp: 'integration-tests',
         *   creatingAppVersion: '0.0.1',
         *   creatingUser: 'integration-tests',
         *   status: 'suggested' as const,
         *   data,
         * };
         * const created = await client.annotations.create([annotation]);
         *
         */
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        /**
         * [Suggest annotations](https://docs.cognite.com/api/playground/#operation/annotationsSuggest)
         *
         * const data = {
         *   pageNumber: 7,
         *   textRegion: { xMin: 0, xMax: 0.1, yMin: 0, yMax: 0.2 },
         *   extractedText: 'i am your father',
         * };
         * const partial = {
         *   annotatedResourceType: 'file' as const,
         *   annotatedResourceId: 1,
         *   annotationType: 'documents.ExtractedText',
         *   creatingApp: 'integration-tests',
         *   creatingAppVersion: '0.0.1',
         *   creatingUser: 'integration-tests',
         *   data,
         * };
         *
         * const created = await client.annotations.suggest([partial]);
         */
        _this.suggest = function (items) {
            return _this.createEndpoint(items, _this.suggestUrl);
        };
        /**
         * [Retrieve](https://docs.cognite.com/api/playground/#operation/annotationsByids)
         * or [Get an](https://docs.cognite.com/api/playground/#operation/annotationsGet)
         * annotation
         *
         * const annotationIds = [{ id: 1 }, { id: 2 }];
         *
         * const response = await client.annotations.retrieve(annotationIds);
         */
        _this.retrieve = function (ids) {
            return _this.retrieveEndpoint(ids);
        };
        /**
         * [Advanced list of annotations](https://docs.cognite.com/api/playground/#operation/annotationsFilter)
         *
         * const annotatedFileId = 1;
         * const limitOne = await client.annotations.list({
         *   limit: 1,
         *   filter: {
         *    annotatedResourceType: 'file',
         *    annotatedResourceIds: [{ id: 1 }],
         *  },
         * });
         *
         */
        _this.list = function (filter) {
            return _this.listEndpoint(_this.callListEndpointWithPost, filter);
        };
        /**
         * [Delete annotations](https://docs.cognite.com/api/playground/#operation/annotationsDelete)
         *
         * const annotationIds = [{ id: 1 }, { id: 2 }];
         *
         * await client.annotations.delete(annotationIds);
         */
        _this.delete = function (ids) {
            return _this.deleteEndpoint(ids);
        };
        /**
         * [Update annotations](https://docs.cognite.com/api/playground/#operation/annotationsUpdate)
         *
         * const data = {
         *   pageNumber: 8,
         *   fileRef: { externalId: 'def_file_changed' },
         *   textRegion: { xMin: 0, xMax: 0.1, yMin: 0, yMax: 0.2 },
         * };
         * const changes = [
         *   {
         *     id: 1,
         *     update: {
         *       data: {
         *         set: data,
         *       },
         *     },
         *   },
         * ];
         *
         * const updatedResp = await client.annotations.update(changes);
         */
        _this.update = function (changes) {
            return _this.updateEndpoint(changes);
        };
        /**
         * [Reverse lookup](https://developer.cognite.com/api/v1-beta/#tag/Annotations/operation/annotationsReverseLookup)
         *
         * const assetQueryData = {
         *   limit: -1,
         *   filter: {
         *     annotatedResourceType: 'file' as const,
         *     annotationType: 'images.AssetLink',
         *     data: {
         *       assetRef: { id: 123 }
         *     }
         *   }
         * };
         * const resourceIdsResponse = client.annotations.reverseLookup(assetQueryData);
         */
        _this.reverseLookup = function (filter) {
            var path = _this.url('reverselookup');
            return _this.cursorBasedEndpoint(function (params) {
                return _this.post(path, {
                    data: params,
                });
            }, filter);
        };
        return _this;
    }
    /**
     * Specify that dates should be parsed in requests and responses
     * @hidden
     */
    AnnotationsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    Object.defineProperty(AnnotationsAPI.prototype, "suggestUrl", {
        get: function () {
            return this.url('suggest');
        },
        enumerable: false,
        configurable: true
    });
    return AnnotationsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var ApiKeysAPI = /** @class */ (function (_super) {
    __extends(ApiKeysAPI, _super);
    function ApiKeysAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create API keys](https://doc.cognitedata.com/api/v1/#operation/createApiKeys)
         *
         * ```js
         * const createdApiKeys = await client.apiKeys.create([{ serviceAccountId: 123 }]);
         * ```
         */
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        /**
         * [List all api keys](https://doc.cognitedata.com/api/v1/#operation/getApiKeys)
         *
         * ```js
         * const apiKeys = await client.apiKeys.list({ all: true });
         * ```
         */
        _this.list = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url();
                        return [4 /*yield*/, this.get(path, {
                                params: scope,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        }); };
        /**
         * [Delete API keys](https://doc.cognitedata.com/api/v1/#operation/deleteApiKeys)
         *
         * ```js
         * await client.apiKeys.delete([123, 456]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    ApiKeysAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime']);
    };
    return ApiKeysAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
/** @hidden */
function enrichAssetsWithTheirParents(assets) {
    var e_1, _a, e_2, _b;
    var externalIdMap = new Map();
    var nodes = assets.map(function (asset) { return ({
        data: asset,
    }); });
    try {
        // find all new exteralIds and map the new externalId to the asset
        for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var node = nodes_1_1.value;
            var externalId = node.data.externalId;
            if (externalId) {
                externalIdMap.set(externalId, node);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        // set correct Node.parentNode
        for (var nodes_2 = __values(nodes), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
            var node = nodes_2_1.value;
            var parentExternalId = node.data.parentExternalId;
            // has an internal parent
            if (parentExternalId && externalIdMap.has(parentExternalId)) {
                node.parentNode = externalIdMap.get(parentExternalId);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (nodes_2_1 && !nodes_2_1.done && (_b = nodes_2.return)) _b.call(nodes_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return nodes;
}
/** @hidden */
function sortAssetCreateItems(assets) {
    var nodes = enrichAssetsWithTheirParents(assets);
    var sortedNodes = sdkCore.GraphUtils.topologicalSort(nodes);
    return sortedNodes.map(function (node) { return node.data; });
}

// Copyright 2020 Cognite AS
var AssetsAPI = /** @class */ (function (_super) {
    __extends(AssetsAPI, _super);
    function AssetsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Creates new assets](https://doc.cognitedata.com/api/v1/#operation/createAssets)
         *
         * ```js
         * const assets = [
         *   { name: 'First asset' },
         *   { name: 'Second asset', description: 'Another asset', externalId: 'anotherAsset' },
         *   { name: 'Child asset', parentExternalId: 'anotherAsset'},
         * ];
         * const createdAssets = await client.assets.create(assets);
         * ```
         */
        _this.create = function (items) {
            var _a = new sdkCore.RevertableArraySorter(sortAssetCreateItems), sort = _a.sort, unsort = _a.unsort;
            return _super.prototype.createEndpoint.call(_this, items, undefined, sort, unsort);
        };
        /**
         * [List assets](https://doc.cognitedata.com/api/v1/#operation/listAssets)
         * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/getAssets) -->
         *
         * ```js
         * const assets = await client.assets.list({ filter: { name: '21PT1019' } });
         * ```
         */
        _this.list = function (scope) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, scope);
        };
        /**
         * [Aggregate assets](https://docs.cognite.com/api/v1/#operation/aggregateAssets)
         *
         * ```js
         * const aggregates = await client.assets.aggregate({ filter: { root: true } });
         * console.log('Number of root assets: ', aggregates[0].count)
         * ```
         */
        _this.aggregate = function (query) {
            return _super.prototype.aggregateEndpoint.call(_this, query);
        };
        /**
         * [Retrieve assets](https://doc.cognitedata.com/api/v1/#operation/byIdsAssets)
         * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/getAsset) -->
         *
         * ```js
         * const assets = await client.assets.retrieve([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.retrieve = function (ids, params) {
            if (params === void 0) { params = {}; }
            return _super.prototype.retrieveEndpoint.call(_this, ids, params);
        };
        /**
         * [Update assets](https://doc.cognitedata.com/api/v1/#operation/updateAssets)
         *
         * ```js
         * const assets = await client.assets.update([{id: 123, update: {name: {set: 'New name'}}}]);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        /**
         * [Search for assets](https://doc.cognitedata.com/api/v1/#operation/searchAssets)
         *
         * ```js
         * const assets = await client.assets.search({
         *   filter: {
         *     parentIds: [1, 2]
         *   },
         *   search: {
         *     query: '21PT1019'
         *   }
         * });
         * ```
         */
        _this.search = function (query) {
            return _super.prototype.searchEndpoint.call(_this, query);
        };
        /**
         * [Delete assets](https://doc.cognitedata.com/api/v1/#operation/deleteAssets)
         *
         * ```js
         * await client.assets.delete([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.delete = function (ids, params) {
            if (params === void 0) { params = {}; }
            var paramsWithIgnoreUnknownIds = __assign(__assign({}, params), { ignoreUnknownIds: true });
            return _super.prototype.deleteEndpoint.call(_this, ids, paramsWithIgnoreUnknownIds);
        };
        return _this;
    }
    /**
     * @hidden
     */
    AssetsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    return AssetsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var ContainersAPI = /** @class */ (function (_super) {
    __extends(ContainersAPI, _super);
    function ContainersAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Upsert containers](https://api-docs.cognite.com/20230101/tag/Containers/operation/ApplyContainers)
         *
         * ```js
         * const containerDefinition = {
         *     "space": "string",
         *     "externalId": "string",
         *     "name": "string",
         *     "description": "string",
         *     "usedFor": "node",
         *     "properties": {
         *     "containerPropertyIdentifier1": {},
         *     "containerPropertyIdentifier2": {}
         *   },
         *   "constraints": {
         *     "constraint-identifier1": {},
         *     "constraint-identifier2": {}
         *   },
         *   "indexes": {
         *     "index-identifier1": {},
         *     "index-identifier2": {}
         *   }
         * }
         *  const response = await client.containers.upsert([
         *   containerDefinition
         *  ]);
         * ```
         */
        _this.upsert = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Delete containers](https://api-docs.cognite.com/20230101/tag/Containers/operation/deleteContainers)
         *
         * ```js
         *  const response = await client.containers.delete([{
         *    space: "my_space",
         *    externalId: "my_external_id"
         *  }]);
         *
         * ```
         */
        _this.delete = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.deleteUrl, {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [List containers](https://api-docs.cognite.com/20230101/tag/Containers/operation/listContainers)
         *
         * ```js
         *  const response = await client.containers.list({ space: '', includeGlobal: true });
         *
         * ```
         */
        _this.list = function (params) {
            if (params === void 0) { params = { includeGlobal: false }; }
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithGet, params);
        };
        /**
         * [Retrieve containers](https://api-docs.cognite.com/20230101/tag/Containers/operation/byExternalIdsContainers)
         *
         * ```js
         *  const response = await client.containers.retrieve([
         *   {
         *    space: "my_space",
         *    externalId: "my_external_id"
         *   }
         * ]);
         *
         * ```
         */
        _this.retrieve = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.byIdsUrl, {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        return _this;
    }
    return ContainersAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var DataPointsAPI = /** @class */ (function (_super) {
    __extends(DataPointsAPI, _super);
    function DataPointsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Insert data points](https://doc.cognitedata.com/api/v1/#operation/postMultiTimeSeriesDatapoints)
         *
         * ```js
         * await client.datapoints.insert([{ id: 123, datapoints: [{timestamp: 1557320284000, value: -2}] }]);
         * ```
         */
        _this.insert = function (items) {
            return _this.insertEndpoint(items);
        };
        /**
         * [Retrieve data points](https://doc.cognitedata.com/api/v1/#operation/getMultiTimeSeriesDatapoints)
         *
         * ```js
         * const data = await client.datapoints.retrieve({ items: [{ id: 123 }] });
         * ```
         */
        _this.retrieve = function (query) {
            return _this.retrieveDatapointsEndpoint(query);
        };
        /**
         *
         * ```js
         * const monthlyAggregatesData = await client.datapoints.retrieveDatapointMonthlyAggregates({ items: [{ id: 123 }] });
         * ```
         */
        _this.retrieveDatapointMonthlyAggregates = function (query) { return __awaiter(_this, void 0, void 0, function () {
            var startDate, endDate, months, promises, results, mergedDatapoints, mergedTimeseries, results_1, results_1_1, result, result_1, result_1_1, item, resultSet, key, item;
            var e_1, _a, e_2, _b, _c;
            var _this = this;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        startDate = query.start;
                        endDate = query.end;
                        if (!(startDate && endDate)) return [3 /*break*/, 2];
                        months = this.getMonthsBetweenDates(startDate, endDate);
                        promises = months.map(function (month) {
                            // Create a new query for each month
                            var newQuery = __assign(__assign({}, query), { start: month.startDate, end: month.endDate, granularity: month.numberOfDays + "d" });
                            // Return a promise for each month
                            return _this.retrieveDatapointsEndpoint(newQuery);
                        });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        results = _e.sent();
                        mergedDatapoints = {};
                        mergedTimeseries = {};
                        try {
                            for (results_1 = __values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                                result = results_1_1.value;
                                try {
                                    // There can be multiple time series in a response, so we need to loop through each item
                                    for (result_1 = (e_2 = void 0, __values(result)), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                                        item = result_1_1.value;
                                        if (!mergedTimeseries[item.id]) {
                                            mergedTimeseries[item.id] = item;
                                        }
                                        if ((_d = item === null || item === void 0 ? void 0 : item.datapoints) === null || _d === void 0 ? void 0 : _d.length) {
                                            if (!mergedDatapoints[item.id]) {
                                                mergedDatapoints[item.id] = item.datapoints;
                                            }
                                            else {
                                                (_c = mergedDatapoints[item.id]).push.apply(_c, __spread(item.datapoints));
                                            }
                                        }
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (result_1_1 && !result_1_1.done && (_b = result_1.return)) _b.call(result_1);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        resultSet = [];
                        for (key in mergedTimeseries) {
                            item = mergedTimeseries[key];
                            if (key in mergedDatapoints) {
                                item.datapoints = mergedDatapoints[key];
                            }
                            else {
                                item.datapoints = [];
                            }
                            resultSet.push(item);
                        }
                        return [2 /*return*/, resultSet];
                    case 2: return [2 /*return*/, this.retrieveDatapointsEndpoint(query)];
                }
            });
        }); };
        /**
         * [Get latest data point in a time series](https://doc.cognitedata.com/api/v1/#operation/getLatest)
         *
         * ```js
         * const datapoints = await client.datapoints.retrieveLatest([
         *   {
         *    before: 'now',
         *    id: 123
         *  },
         *  {
         *    externalId: 'abc',
         *    before: new Date('21 jan 2018'),
         *  }
         * ]);
         * ```
         */
        _this.retrieveLatest = function (items, params) {
            if (params === void 0) { params = {}; }
            return _this.retrieveLatestEndpoint(items, params);
        };
        /**
         * [Delete data points](https://doc.cognitedata.com/api/v1/#operation/deleteDatapoints)
         *
         * ```js
         * await client.datapoints.delete([{id: 123, inclusiveBegin: new Date('1 jan 2019')}]);
         * ```
         */
        _this.delete = function (items) {
            return _this.deleteDatapointsEndpoint(items);
        };
        _this.getMonthsBetweenDates = function (startDate, endDate) {
            var result = [];
            var currentMonth = new Date(startDate);
            while (currentMonth <= new Date(endDate)) {
                var firstDay = new Date(Date.UTC(currentMonth.getFullYear(), currentMonth.getMonth(), 1, 0));
                var lastDay = new Date(Date.UTC(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1, 0));
                result.push({
                    startDate: firstDay.getTime(),
                    endDate: lastDay.getTime(),
                    numberOfDays: (lastDay.getTime() - firstDay.getTime()) / (24 * 3600 * 1000),
                });
                // Move to the next month
                currentMonth.setMonth(currentMonth.getMonth() + 1);
            }
            return result;
        };
        return _this;
    }
    /**
     * @hidden
     */
    DataPointsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items', 'datapoints'], ['timestamp']);
    };
    DataPointsAPI.prototype.insertEndpoint = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url();
                        return [4 /*yield*/, this.postInParallelWithAutomaticChunking({ path: path, items: items })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, {}];
                }
            });
        });
    };
    DataPointsAPI.prototype.retrieveDatapointsEndpoint = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.listPostUrl;
                        return [4 /*yield*/, this.post(path, {
                                data: query,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        });
    };
    DataPointsAPI.prototype.retrieveLatestEndpoint = function (items, params) {
        return __awaiter(this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url('latest');
                        return [4 /*yield*/, this.post(path, {
                                data: __assign({ items: items }, params),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        });
    };
    DataPointsAPI.prototype.deleteDatapointsEndpoint = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postInParallelWithAutomaticChunking({
                            chunkSize: 10000,
                            items: items,
                            path: this.deleteUrl,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, {}];
                }
            });
        });
    };
    return DataPointsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var DataSetsAPI = /** @class */ (function (_super) {
    __extends(DataSetsAPI, _super);
    function DataSetsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create datasets](https://docs.cognite.com/api/v1/#operation/createDataSets)
         *
         * ```js
         * const datasets = [
         *   { externalId: 'sensitiveData' },
         *   { writeProtected: true }
         * ];
         * const createdDatasets = await client.datasets.create(datasets);
         * ```
         */
        _this.create = function (items) {
            return _super.prototype.createEndpoint.call(_this, items);
        };
        /**
         * [List data sets](https://docs.cognite.com/api/v1/#operation/listDataSets)
         *
         * ```js
         * const dataSets = await client.datasets.list({ filter: { createdTime: { min: new Date('1 jan 2018'), max: new Date('1 jan 2019') }}});
         * ```
         */
        _this.list = function (query) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, query);
        };
        /**
         * [Aggregate datasets](https://docs.cognite.com/api/v1/#operation/aggregateDataSets)
         *
         * ```js
         * const aggregates = await client.datasets.aggregate({ filter: { writeProtected: true } });
         * console.log('Number of write protected datasets: ', aggregates[0].count)
         * ```
         */
        _this.aggregate = function (query) {
            return _super.prototype.aggregateEndpoint.call(_this, query);
        };
        /**
         * [Retrieve data sets](https://docs.cognite.com/api/v1/#operation/getDataSets)
         *
         * ```js
         * const dataSets = await client.datasets.retrieve([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.retrieve = function (ids, params) {
            return _super.prototype.retrieveEndpoint.call(_this, ids, params);
        };
        /**
         * [Update data sets](https://docs.cognite.com/api/v1/#operation/updateDataSets)
         *
         * ```js
         * const dataSets = await client.datasets.update([{id: 123, update: {description: {set: 'New description'}}}]);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        return _this;
    }
    /**
     * @hidden
     */
    DataSetsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    return DataSetsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
/**
 * Documents aggregate API.
 *
 * Note that only "allUniqueValues" requires pagination, and we therefore
 * configure the BaseResourceAPI to work for only that feature.
 */
var DocumentsAggregateAPI = /** @class */ (function (_super) {
    __extends(DocumentsAggregateAPI, _super);
    function DocumentsAggregateAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.count = function (request) {
            return _this.aggregate(__assign(__assign({}, request), { aggregate: 'count' })).then(function (response) { return response[0].count; });
        };
        _this.uniqueValues = function (request) {
            return _this.aggregate(__assign(__assign({}, request), { aggregate: 'uniqueValues' }));
        };
        _this.allUniqueValues = function (request) {
            return _this.cursorBasedEndpoint(_this.callAggregateCursorEndpointWithPost, __assign(__assign({}, request), { aggregate: 'allUniqueValues' }));
        };
        _this.uniqueProperties = function (request) {
            return _this.aggregate(__assign(__assign({}, request), { aggregate: 'uniqueProperties' }));
        };
        _this.allUniqueProperties = function (request) {
            return _this.cursorBasedEndpoint(_this.callAggregateCursorEndpointWithPost, __assign(__assign({}, request), { aggregate: 'allUniqueProperties' }));
        };
        _this.callAggregateCursorEndpointWithPost = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), {
                            data: scope,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        return _this;
    }
    DocumentsAggregateAPI.prototype.aggregate = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), {
                            data: request,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        });
    };
    return DocumentsAggregateAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
var PreviewAPI = /** @class */ (function (_super) {
    __extends(PreviewAPI, _super);
    function PreviewAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.documentAsPdf = function (id) {
            return _this.pdfPreviewEndpoint(id);
        };
        _this.documentAsImage = function (id, page) {
            return _this.imagePreviewEndpoint(id, page);
        };
        _this.pdfTemporaryLink = function (id) {
            return _this.pdfTemporaryLinkEndpoint(id);
        };
        _this.pdfBuildPreviewURI = function (id) {
            return "" + _this.url() + id.toString() + "/preview/pdf";
        };
        _this.imageBuildPreviewURI = function (id, page) {
            if (page === void 0) { page = 1; }
            return "" + _this.url() + id.toString() + "/preview/image/pages/" + page.toString();
        };
        _this.pdfBuildTemporaryLinkURI = function (id) {
            return "" + _this.url() + id.toString() + "/preview/pdf/temporarylink";
        };
        return _this;
    }
    PreviewAPI.prototype.pdfPreviewEndpoint = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var uri, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = this.pdfBuildPreviewURI(id);
                        return [4 /*yield*/, this.get(uri, {
                                responseType: sdkCore.HttpResponseType.ArrayBuffer,
                                headers: {
                                    Accept: 'application/pdf',
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    PreviewAPI.prototype.imagePreviewEndpoint = function (id, page) {
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var uri, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = this.imageBuildPreviewURI(id, page);
                        return [4 /*yield*/, this.get(uri, {
                                responseType: sdkCore.HttpResponseType.ArrayBuffer,
                                headers: {
                                    Accept: 'image/png',
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    PreviewAPI.prototype.pdfTemporaryLinkEndpoint = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var uri, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = this.pdfBuildTemporaryLinkURI(id);
                        return [4 /*yield*/, this.get(uri)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return PreviewAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
var DocumentsAPI = /** @class */ (function (_super) {
    __extends(DocumentsAPI, _super);
    function DocumentsAPI() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        /**
         * [Search for documents](https://docs.cognite.com/api/v1/#operation/documentsSearch)
         *
         * ```js
         * const documents = await client.documents.search({
         *   search: {
         *     query: 'Stuck pipe'
         *   },
         *   filter: {
         *     in: {
         *       property: ['type'],
         *       values: ['Document', 'PDF']
         *     }
         *   },
         *   limit: 5
         * });
         * ```
         */
        _this.search = function (query) {
            return _this.searchDocuments(query);
        };
        _this.list = function (request) {
            return _this.listEndpoint(_this.callListEndpointWithPost, request);
        };
        _this.content = function (id) {
            return _this.documentContent(id);
        };
        var _a = __read(args, 3), baseUrl = _a[0], httpClient = _a[1], map = _a[2];
        _this.previewAPI = new PreviewAPI(baseUrl, httpClient, map);
        _this.aggregateAPI = new DocumentsAggregateAPI(baseUrl + "/aggregate", httpClient, map);
        return _this;
    }
    Object.defineProperty(DocumentsAPI.prototype, "preview", {
        get: function () {
            return this.previewAPI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DocumentsAPI.prototype, "aggregate", {
        get: function () {
            return this.aggregateAPI;
        },
        enumerable: false,
        configurable: true
    });
    DocumentsAPI.prototype.searchDocuments = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.searchUrl, {
                            data: query,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        });
    };
    DocumentsAPI.prototype.documentContent = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(this.url(id + "/content"), {
                            headers: {
                                accept: 'text/plain',
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return DocumentsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var EntityMatchingApi = /** @class */ (function (_super) {
    __extends(EntityMatchingApi, _super);
    function EntityMatchingApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create entity matcher](https://docs.cognite.com/api/v1/#operation/entityMatchingCreate)
         *
         * ```js
         * const result = await client.entityMatching.create({
         *  sources: [{externalId: 'asset1', name: 'asset1'}, {externalId: 'asset2', name: 'asset2'}],
         *  targets: [{externalId: 'ts1', name: 'ts1'}, {externalId: 'ts2', name: 'ts2'}],
         *  externalId: 'model123',
         *  name: 'model123',
         * });
         * ```
         */
        _this.create = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url();
                        return [4 /*yield*/, this.post(path, {
                                data: scope,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Retrieve entity matching models](https://docs.cognite.com/api/v1/#operation/entityMatchingRetrieve)
         *
         * ```js
         * const [result] = await client.entityMatching.retrieve([{ externalId: 'model123' }]);
         * ```
         */
        _this.retrieve = function (ids) {
            return _super.prototype.retrieveEndpoint.call(_this, ids);
        };
        /**
         * [List entity matching models](https://docs.cognite.com/api/v1/#operation/entityMatchingFilter)
         *
         * ```js
         * const { items } = await client.entityMatching.list({ filter: { name: 'model123' }});
         * ```
         */
        _this.list = function (scope) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, scope);
        };
        /**
         * [Update entity matching models](https://docs.cognite.com/api/v1/#operation/entityMatchingUpdate)
         *
         * ```js
         * const [updated] = await client.entityMatching.update([{
         *  externalId: 'model123',
         *  update: { description: { set: 'ø' }}
         * }]);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        /**
         * [Delete entity matcher model](https://docs.cognite.com/api/v1/#operation/entityMatchingDelete)
         *
         * ```js
         * await client.entityMatching.delete([{ externalId: 'model123' }]);
         * ```
         */
        _this.delete = function (ids) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.deleteEndpoint.call(this, ids)];
            });
        }); };
        /**
         * [Predict matches](https://docs.cognite.com/api/v1/#operation/entityMatchingPredict)
         *
         * ```js
         * const response = await client.entityMatching.predict({
         *  externalId: 'model123',
         *  sources: [{externalId: 'asset1', name: 'asset1'}, {externalId: 'asset2', name: 'asset2'}],
         *  targets: [{externalId: 'ts1', name: 'ts1'}, {externalId: 'ts2', name: 'ts2'}],
         * });
         * ```
         */
        _this.predict = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url('predict');
                        return [4 /*yield*/, this.post(path, {
                                data: scope,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Retrieve entity matcher predict result](https://docs.cognite.com/api/playground/#operation/entityMatchingPredictResults)
         *
         * ```js
         * const { status, items } = await client.entityMatching.predictResult(12345678);
         * ```
         */
        _this.predictResult = function (jobId) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url("jobs/" + jobId);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Re-fit entity matcher model](https://docs.cognite.com/api/v1/#operation/entityMatchingReFit)
         *
         * ```js
         * await client.entityMatching.refit({
         *  newExternalId: 'newModel123',
         *  sources: [{externalId: 'asset1', name: 'asset1'}, {externalId: 'asset2', name: 'asset2'}],
         *  targets: [{externalId: 'ts1', name: 'ts1'}, {externalId: 'ts2', name: 'ts2'}],
         *  externalId: 'model123',
         *  trueMatches: [{sourceExternalId: 'asset1', targetExternalId: 'ts1'}]
         * });
         * ```
         */
        _this.refit = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url('refit');
                        return [4 /*yield*/, this.post(path, {
                                data: scope,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        return _this;
    }
    /**
     * @hidden
     */
    EntityMatchingApi.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'startTime', 'statusTime']);
    };
    return EntityMatchingApi;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var EventsAggregateAPI = /** @class */ (function (_super) {
    __extends(EventsAggregateAPI, _super);
    function EventsAggregateAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Aggregate events](https://docs.cognite.com/api/v1/#operation/aggregateEvents)
         *
         * ```js
         * const aggregates = await client.events.aggregate.count({ filter: { assetIds: [1, 2, 3] } });
         * console.log('Number of events: ', aggregates[0].count)
         * ```
         */
        _this.count = function (query) {
            return _super.prototype.aggregateEndpoint.call(_this, query);
        };
        /**
         * [Aggregate events](https://docs.cognite.com/api/v1/#operation/aggregateEvents)
         *
         * ```js
         * const uniqueValues = await client.events.aggregate.uniqueValues({ filter: { assetIds: [1, 2, 3] }, fields: ['subtype'] });
         * console.log('Unique values: ', uniqueValues)
         * ```
         */
        _this.uniqueValues = function (query) {
            return _super.prototype.aggregateEndpoint.call(_this, __assign(__assign({}, query), { aggregate: 'uniqueValues' }));
        };
        return _this;
    }
    return EventsAggregateAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var EventsAPI = /** @class */ (function (_super) {
    __extends(EventsAPI, _super);
    function EventsAPI() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        /**
         * [Create events](https://doc.cognitedata.com/api/v1/#operation/createEvents)
         *
         * ```js
         * const events = [
         *   { description: 'Workorder pump abc', startTime: new Date('22 jan 2019') },
         *   { description: 'Broken rule', externalId: 'rule123', startTime: 1557346524667000 },
         * ];
         * const createdEvents = await client.events.create(events);
         * ```
         */
        _this.create = function (items) {
            return _super.prototype.createEndpoint.call(_this, items);
        };
        /**
         * [List events](https://doc.cognitedata.com/api/v1/#operation/advancedListEvents)
         * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/listEvents) -->
         *
         * ```js
         * const events = await client.events.list({ filter: { startTime: { min: new Date('1 jan 2018') }, endTime: { max: new Date('1 jan 2019') } } });
         * ```
         */
        _this.list = function (scope) {
            var _a = scope || {}, _b = _a.sort, sortObject = _b === void 0 ? {} : _b, rest = __rest(_a, ["sort"]);
            var query = __assign({ sort: _this.convertSortObjectToArray(sortObject) }, rest);
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, query);
        };
        /**
         * [Retrieve events](https://doc.cognitedata.com/api/v1/#operation/byIdsEvents)
         * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/getEventByInternalId) -->
         *
         * ```js
         * const events = await client.events.retrieve([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.retrieve = function (ids, params) {
            if (params === void 0) { params = {}; }
            return _super.prototype.retrieveEndpoint.call(_this, ids, params);
        };
        /**
         * [Update events](https://doc.cognitedata.com/api/v1/#operation/updateEvents)
         *
         * ```js
         * const events = await client.events.update([{id: 123, update: {description: {set: 'New description'}}}]);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        /**
         * [Search for events](https://doc.cognitedata.com/api/v1/#operation/searchEvents)
         *
         * ```js
         * const events = await client.events.search({
         *   filter: {
         *     assetIds: [1, 2]
         *   },
         *   search: {
         *     description: 'Pump'
         *   }
         * });
         * ```
         */
        _this.search = function (query) {
            return _super.prototype.searchEndpoint.call(_this, query);
        };
        /**
         * [Delete events](https://doc.cognitedata.com/api/v1/#operation/deleteEvents)
         *
         * ```js
         * await client.events.delete([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        _this.aggregateAPI = new (EventsAggregateAPI.bind.apply(EventsAggregateAPI, __spread([void 0], args)))();
        return _this;
    }
    /**
     * @hidden
     */
    EventsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    Object.defineProperty(EventsAPI.prototype, "aggregate", {
        /**
         * The aggregation API allows you to compute aggregated results on events like getting the count of all events
         * in a project or checking what are all the different types and subtypes of events in your project,
         * along with the count of events in each of those aggregations.
         * By specifying an additional filter, you can also aggregate only among events matching the specified filter.
         */
        get: function () {
            return this.aggregateAPI;
        },
        enumerable: false,
        configurable: true
    });
    EventsAPI.prototype.convertSortObjectToArray = function (sortObject) {
        return Object.entries(sortObject).map(function (_a) {
            var _b = __read(_a, 2), prop = _b[0], order = _b[1];
            return prop + ":" + order;
        });
    };
    return EventsAPI;
}(sdkCore.BaseResourceAPI));

var UploadAlreadyFinishedError = /** @class */ (function (_super) {
    __extends(UploadAlreadyFinishedError, _super);
    function UploadAlreadyFinishedError() {
        return _super.call(this, 'Upload has already finished') || this;
    }
    return UploadAlreadyFinishedError;
}(Error));

var FilesMultipartUploadSessionAPI = /** @class */ (function (_super) {
    __extends(FilesMultipartUploadSessionAPI, _super);
    function FilesMultipartUploadSessionAPI() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.call(this, args[0], args[1], args[2]) || this;
        _a = __read(args, 4), _this.multiPartFileUploadResponse = _a[3];
        _this.uploadedUrls = _this.multiPartFileUploadResponse.uploadUrls.map(function (_) { return false; });
        _this.finished = false;
        return _this;
    }
    FilesMultipartUploadSessionAPI.prototype.uploadPart = function (partNumber, fileContent) {
        return __awaiter(this, void 0, void 0, function () {
            var hasFileContent, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hasFileContent = fileContent != null;
                        if (!hasFileContent) {
                            throw Error('you are uploading empty content');
                        }
                        if (partNumber < 0 ||
                            partNumber >= this.multiPartFileUploadResponse.uploadUrls.length) {
                            throw Error("part number is outside allowed range 0 to " + (this.multiPartFileUploadResponse.uploadUrls.length - 1));
                        }
                        if (!this.canCompleteUpload()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.completeMultiPartUpload()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        if (this.alreadyUploadedPart(partNumber)) {
                            return [2 /*return*/];
                        }
                        if (this.multiPartFileUploadResponse.uploadUrls[partNumber] === null) {
                            throw Error('part number is not valid');
                        }
                        if (!(fileContent != null)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.put(this.multiPartFileUploadResponse.uploadUrls[partNumber], {
                                data: fileContent,
                            })];
                    case 3:
                        response = _a.sent();
                        if (!(response.status === 200 || response.status === 201)) return [3 /*break*/, 6];
                        this.uploadedUrls[partNumber] = true;
                        if (!this.canCompleteUpload()) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.completeMultiPartUpload()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, { partNumber: partNumber, status: response.status }];
                    case 6: return [2 /*return*/, { partNumber: partNumber, status: response.status }];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    FilesMultipartUploadSessionAPI.prototype.alreadyUploadedPart = function (partNumber) {
        return this.uploadedUrls[partNumber];
    };
    FilesMultipartUploadSessionAPI.prototype.canCompleteUpload = function () {
        return (this.uploadedUrls.length !== 0 && this.getNotCompletedParts().length === 0);
    };
    FilesMultipartUploadSessionAPI.prototype.completeMultiPartUpload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var path, requestBody, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.finished) {
                            throw new UploadAlreadyFinishedError();
                        }
                        if (!this.canCompleteUpload()) {
                            return [2 /*return*/];
                        }
                        path = this.url('completemultipartupload');
                        requestBody = {
                            id: this.multiPartFileUploadResponse.id,
                            uploadId: this.multiPartFileUploadResponse.uploadId,
                        };
                        return [4 /*yield*/, this.post(path, {
                                data: requestBody,
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.status !== 200) {
                            throw Error('upload cannot be completed');
                        }
                        this.finished = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    FilesMultipartUploadSessionAPI.prototype.getNotCompletedParts = function () {
        return this.uploadedUrls.reduce(function (acc, curr, index) {
            if (curr === false) {
                acc.push(index);
            }
            return acc;
        }, []);
    };
    FilesMultipartUploadSessionAPI.prototype.getMultiPartFileUploadId = function () {
        return this.multiPartFileUploadResponse.uploadId;
    };
    FilesMultipartUploadSessionAPI.prototype.getFinished = function () {
        return this.finished;
    };
    return FilesMultipartUploadSessionAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var FilesAPI = /** @class */ (function (_super) {
    __extends(FilesAPI, _super);
    function FilesAPI() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        _this.limits = {
            minimumNumberOfParts: 1,
            maxNumberOfParts: 250,
        };
        /**
         * [Upload a file](https://doc.cognitedata.com/api/v1/#operation/initFileUpload)
         *
         * ```js
         * const fileContent = 'file data here'; // can also be of type ArrayBuffer, Buffer, Blob, File or any
         * // automatic upload:
         * const file = await client.files.upload({name: 'examplefile.jpg', mimeType: 'image/jpeg'}, fileContent);
         *
         * // manual with uploadUrl:
         * const file2 = await client.files.upload({name: 'examplefile.jpg', mimeType: 'image/jpeg'});
         * // then upload using the file.uploadUrl
         * ```
         */
        _this.upload = function (fileInfo, fileContent, overwrite, waitUntilAcknowledged) {
            if (overwrite === void 0) { overwrite = false; }
            if (waitUntilAcknowledged === void 0) { waitUntilAcknowledged = false; }
            return _this.uploadEndpoint(fileInfo, fileContent, overwrite, waitUntilAcknowledged);
        };
        /**
         * [List files](https://doc.cognitedata.com/api/v1/#operation/advancedListFiles)
         * <!-- or [similar](https://doc.cognitedata.com/api/v1/#operation/listFiles) -->
         *
         * ```js
         * const files = await client.files.list({filter: {mimeType: 'image/png'}});
         * ```
         */
        _this.list = function (scope) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, scope);
        };
        /**
         * [Aggregate files](https://docs.cognite.com/api/v1/#operation/aggregateFiles)
         *
         * ```js
         * const aggregates = await client.files.aggregate({ filter: { uploaded: true } });
         * console.log('Number of uploaded files: ', aggregates[0].count)
         * ```
         */
        _this.aggregate = function (query) {
            return _super.prototype.aggregateEndpoint.call(_this, query);
        };
        /**
         * [Retrieve files](https://doc.cognitedata.com/api/v1/#operation/byIdsFiles)
         * <!-- or [just one](https://doc.cognitedata.com/api/v1/#operation/getFileByInternalId) -->
         *
         * ```js
         * const files = await client.files.retrieve([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.retrieve = function (ids, params) {
            if (params === void 0) { params = {}; }
            return _super.prototype.retrieveEndpoint.call(_this, ids, params);
        };
        /**
         * [Update files](https://doc.cognitedata.com/api/v1/#operation/updateFiles)
         *
         * ```js
         * const files = await client.files.update([{
         *   id: 123,
         *   update: {
         *     source: { set: 'new source' }
         *   }
         * }]);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        /**
         * [Search for files](https://doc.cognitedata.com/api/v1/#operation/searchFiles)
         *
         * ```js
         * const files = await client.files.search({
         *   filter: {
         *     mimeType: 'image/jpeg',
         *   },
         *   search: {
         *     name: 'Pump'
         *   }
         * });
         * ```
         */
        _this.search = function (query) {
            return _super.prototype.searchEndpoint.call(_this, query);
        };
        /**
         * [Delete files](https://doc.cognitedata.com/api/v1/#operation/deleteFiles)
         *
         * ```js
         * await client.files.delete([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        /**
         * [Get download urls](https://doc.cognitedata.com/api/v1/#operation/downloadLinks)
         *
         * ```js
         * await client.files.getDownloadUrls([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.getDownloadUrls = function (ids) {
            return _this.getDownloadUrlsEndpoint(ids);
        };
        _a = __read(args, 3), _this._baseUrl = _a[0], _this._client = _a[1], _this._map = _a[2];
        return _this;
    }
    /**
     * Specify that dates should be parsed in requests and responses
     * @hidden
     */
    FilesAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], [
            'createdTime',
            'lastUpdatedTime',
            'sourceCreatedTime',
            'sourceModifiedTime',
            'uploadedTime',
        ]);
    };
    FilesAPI.prototype.uploadEndpoint = function (fileInfo, fileContent, overwrite, waitUntilAcknowledged) {
        if (overwrite === void 0) { overwrite = false; }
        if (waitUntilAcknowledged === void 0) { waitUntilAcknowledged = false; }
        return __awaiter(this, void 0, void 0, function () {
            var hasFileContent, params, path, response, file, uploadedFile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hasFileContent = fileContent != null;
                        if (!hasFileContent && waitUntilAcknowledged) {
                            throw Error("Don't set waitUntilAcknowledged to true when you are not uploading a file");
                        }
                        params = { overwrite: overwrite };
                        path = this.url();
                        return [4 /*yield*/, this.post(path, {
                                params: params,
                                data: fileInfo,
                            })];
                    case 1:
                        response = _a.sent();
                        file = response.data;
                        if (!(fileContent != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.uploadFile(file.uploadUrl, fileContent, fileInfo.mimeType)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!waitUntilAcknowledged) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.waitUntilFileIsUploaded(file.id)];
                    case 4:
                        uploadedFile = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(uploadedFile, response)];
                    case 5: return [2 /*return*/, this.addToMapAndReturn(file, response)];
                }
            });
        });
    };
    FilesAPI.prototype.uploadFile = function (url, fileContent, mimeType) {
        var headers = {
            'Content-Type': mimeType || 'application/octet-stream',
        };
        return this.put(url, {
            headers: headers,
            data: fileContent,
        });
    };
    // TODO: refactor - similar to RetryableHttpClient.rawRequest
    FilesAPI.prototype.waitUntilFileIsUploaded = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            var MAX_RETRIES, DELAY_IN_MS, retryCount, _a, fileInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        MAX_RETRIES = 10;
                        DELAY_IN_MS = 500;
                        retryCount = 0;
                        _b.label = 1;
                    case 1: return [4 /*yield*/, this.retrieve([{ id: fileId }])];
                    case 2:
                        _a = __read.apply(void 0, [_b.sent(), 1]), fileInfo = _a[0];
                        if (fileInfo.uploaded) {
                            return [2 /*return*/, fileInfo];
                        }
                        retryCount++;
                        return [4 /*yield*/, sdkCore.sleepPromise(DELAY_IN_MS)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        if (retryCount < MAX_RETRIES) return [3 /*break*/, 1];
                        _b.label = 5;
                    case 5: throw Error("File never marked as 'uploaded'");
                }
            });
        });
    };
    FilesAPI.prototype.getDownloadUrlsEndpoint = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url('downloadlink');
                        return [4 /*yield*/, this.post(path, { data: { items: items } })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        });
    };
    /**
     * [Init a multipart file upload](https://api-docs.cognite.com/20230101/tag/Files/operation/initMultiPartUpload)
     *
     * ```js
     * // Each file part must be larger than 5 MiB, and smaller than 4000 MiB. The file part for the last uploadURL can be smaller than 5 MiB.
     * const numberOfParts = 5;
     * // automatic upload:
     * const multiPartUploadApi = await client.files.multipartUploadSession({name: 'examplefile.jpg', mimeType: 'image/jpeg'}, numberOfParts);
     * ```
     */
    FilesAPI.prototype.multipartUploadSession = function (fileInfo, parts, overwrite) {
        if (overwrite === void 0) { overwrite = false; }
        return __awaiter(this, void 0, void 0, function () {
            var response, multipartUploadSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMultipartUploadSession(fileInfo, parts, overwrite)];
                    case 1:
                        response = _a.sent();
                        multipartUploadSession = new FilesMultipartUploadSessionAPI(this._baseUrl, this._client, this._map, response.data);
                        return [2 /*return*/, this.addToMapAndReturn(multipartUploadSession, response)];
                }
            });
        });
    };
    FilesAPI.prototype.getMultipartUploadSession = function (fileInfo, parts, overwrite) {
        if (overwrite === void 0) { overwrite = false; }
        return __awaiter(this, void 0, void 0, function () {
            var path, params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (parts < this.limits.minimumNumberOfParts ||
                            parts > this.limits.maxNumberOfParts) {
                            throw Error("parts must be in range " + this.limits.minimumNumberOfParts + " <= parts <= " + this.limits.maxNumberOfParts);
                        }
                        path = this.url('initmultipartupload');
                        params = { overwrite: overwrite, parts: parts };
                        return [4 /*yield*/, this.post(path, {
                                params: params,
                                data: fileInfo,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return FilesAPI;
}(sdkCore.BaseResourceAPI));

var ComputeAPI = /** @class */ (function (_super) {
    __extends(ComputeAPI, _super);
    function ComputeAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Compute custom json output structures or well known binary format responses based on calculation or selection of feature properties or direct values given in the request.](https://docs.cognite.com/api/v1/#operation/compute)
         *
         * ```js
         *
         * const response = await client.geospatial.compute.compute({
         *   output: {
         *     "output": {
         *       stTransform: {
         *         geometry: {
         *           ewkt: "SRID=4326;POLYGON((0 0,10 0,10 10,0 10,0 0))"
         *         },
         *         srid: 4326,
         *       }
         *     }
         *   }
         * });
         * ```
         */
        _this.compute = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url();
                        return [4 /*yield*/, this.post(path, {
                                data: request,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        return _this;
    }
    return ComputeAPI;
}(sdkCore.BaseResourceAPI));

var CrsAPI = /** @class */ (function (_super) {
    __extends(CrsAPI, _super);
    function CrsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create Coordinate Reference Systems](https://docs.cognite.com/api/v1/#operation/createGeospatialCoordinateReferenceSystems)
         *
         * ```js
         * const crsToCreate = [{
         *  srid: 456789,
         *  wkt: 'GEOGCS[\"WGS 84\",DATUM[\"WGS_1984\",SPHEROID[\"WGS 84\",6378137,298.257223563,AUTHORITY[\"EPSG\",\"7030\"]],AUTHORITY[\"EPSG\",\"6326\"]],PRIMEM[\"Greenwich\",0,AUTHORITY[\"EPSG\",\"8901\"]],UNIT[\"degree\",0.0174532925199433,AUTHORITY[\"EPSG\",\"9122\"]],AUTHORITY[\"EPSG\",\"4326\"]]',
         *  projString: '+proj=longlat +datum=WGS84 +no_defs \"\"'
         *  }];
         *
         * const createdCRS = await client.geospatial.crs.create(crsToCreate);
         * ```
         */
        _this.create = function (crs) {
            return _this.createEndpoint(crs);
        };
        /**
         * [Get Coordinate Reference Systems](https://docs.cognite.com/api/v1/#operation/getCoordinateReferenceSystem)
         *
         * ```js
         * const retrievedCRS = await client.geospatial.crs.retrieve([{ srid: 4326 }]);
         * ```
         */
        _this.retrieve = function (srids) {
            // @ts-ignore geospatial team should accept ids probably to be in synergy with sdk
            return _this.retrieveEndpoint(srids);
        };
        /**
         * [List Coordinate Reference Systems](https://docs.cognite.com/api/v1/#operation/listGeospatialCoordinateReferenceSystems)
         *
         * ```js
         * const allCRS = await client.geospatial.crs.list({ filterOnlyCustom : true });
         * ```
         */
        _this.list = function (params) {
            return _this.listEndpoint(_this.callListEndpointWithGet, params);
        };
        /**
         * [Delete Coordinate Reference Systems](https://docs.cognite.com/api/v1/#operation/deleteGeospatialCoordinateReferenceSystems)
         *
         * ```js
         * await client.geospatial.crs.delete([{ srid: 4326}]);
         * ```
         */
        _this.delete = function (srids) {
            return _this.deleteEndpoint(srids);
        };
        return _this;
    }
    return CrsAPI;
}(sdkCore.BaseResourceAPI));

var FeatureAPI = /** @class */ (function (_super) {
    __extends(FeatureAPI, _super);
    function FeatureAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create features](https://docs.cognite.com/api/v1/#operation/createFeatures)
         *
         * ```js
         * const featureTypeExternalId = 'ocean_temperature';
         * const features = [
         *   { externalId: 'measurement_point_765', temperature: 5.65, location: { wkt: 'POINT(60.547602 -5.423433)' }},
         *   { externalId: 'measurement_point_863', temperature: 5.03, location: { wkt: 'POINT(60.585858 -6.474416)' }},
         * ];
         * const createdFeatures = await client.geospatial.feature.create(featureTypeExternalId, features);
         * ```
         */
        _this.create = function (featureTypeExternalId, features) {
            return _this.createEndpoint(features, _this.url(featureTypeExternalId + "/features"));
        };
        /**
         * [Retrieve features](https://docs.cognite.com/api/v1/#operation/getFeaturesByIds)
         *
         * ```js
         * const featuresToRetrieve = [{ externalId: 'measurement_point_765' }, { externalId: 'measurement_point_765' }];
         * const outputParams = { output: { geometryFormat: 'GEOJSON' as const } };
         *
         * const retrievedFeatures = await client.geospatial.feature.retrieve('ocean_temperature', featuresToRetrieve, outputParams);
         * ```
         */
        _this.retrieve = function (featureTypeExternalId, externalIds, params) {
            return _this.callEndpointWithMergeAndTransform(externalIds, function (request) {
                return _this.postInParallelWithAutomaticChunking({
                    path: _this.url(featureTypeExternalId + "/features/byids"),
                    items: request,
                    params: params,
                });
            });
        };
        /**
         * [Update features](https://docs.cognite.com/api/v1/#operation/updateFeatures)
         *
         * ```js
         * const featuresToUpdate = [
         * { externalId: 'measurement_point_765', temperature: 5.65, location: { wkt: 'POINT(60.547602 -5.423433)' } },
         * { externalId: 'measurement_point_863', temperature: 5.03, location: { wkt: 'POINT(60.585858 -6.474416)' } }
         * ];
         *
         * const updatedFeatures = await client.geospatial.feature.update('ocean_temperature', featuresToUpdate);
         * ```
         */
        _this.update = function (featureTypeExternalId, changes) {
            return _this.updateEndpoint(changes, _this.url(featureTypeExternalId + "/features/update"));
        };
        /**
         * [Update features](https://docs.cognite.com/api/v1/#operation/updateFeatures)
         *
         * ```js
         * const featuresToDelete = [{ externalId: 'measurement_point_765' }, { externalId: 'measurement_point_765' }];
         *
         * await client.geospatial.feature.delete('ocean_temperature', featuresToDelete);
         * ```
         */
        _this.delete = function (featureTypeExternalId, externalIds) {
            return _this.deleteEndpoint(externalIds, {}, _this.url(featureTypeExternalId + "/features/delete"));
        };
        /**
         * [Search features](https://docs.cognite.com/api/v1/#operation/searchFeatures)
         *
         * ```js
         * const params = {
         *  filter: {
         *    and: [
         *      { range:{ property: 'temperature', gt:4.54 } },
         *      { stWithin: { property:'location', value:'POLYGON((60.547602 -5.423433, 60.547602 -6.474416, 60.585858 -5.423433, 60.547602 -5.423433))' } }
         *   ]
         *  },
         *  limit: 100,
         *  sort: [ 'temperature:ASC','location']
         * };
         *
         * const searchedFeatures = await client.geospatial.feature.search('ocean_temperature', params);
         * ```
         */
        _this.search = function (featureTypeExternalId, params) {
            if (params === void 0) { params = {}; }
            return _this.searchEndpoint(params, _this.url(featureTypeExternalId + "/features/search"));
        };
        /**
         * [Search and stream features](https://docs.cognite.com/api/v1/#operation/searchFeaturesStreaming)
         *
         * ```js
         * const params = {
         *  filter: {
         *    and: [
         *      { range:{ property: 'temperature', gt:4.54 } },
         *      { stWithin: { property:'location', value:'POLYGON((60.547602 -5.423433, 60.547602 -6.474416, 60.585858 -5.423433, 60.547602 -5.423433))' } }
         *   ]
         *  },
         *  limit: 100,
         *  output: { jsonStreamFormat: 'NEW_LINE_DELIMITED' as const }
         * };
         *
         * const featureStreamString = await client.geospatial.feature.searchStream('ocean_temperature', params);
         * ```
         */
        _this.searchStream = function (featureTypeExternalId, params) {
            if (params === void 0) { params = {}; }
            return _this.callSearchEndpoint(params, _this.url(featureTypeExternalId + "/features/search-streaming")
            // not using addToMapAndReturn in then as WeakMap does not accept primitive values as key and we've string as our response
            ).then(function (response) { return response.data; });
        };
        /**
         * [Aggregate features](https://docs.cognite.com/api/v1/#operation/aggregateFeatures)
         *
         * ```js
         * const aggregateParams = {
         *  filter: {
         *    and: [
         *      { range:{ property: 'temperature', gt:4.54 } },
         *      { stWithin: { property:'location', value:'POLYGON((60.547602 -5.423433, 60.547602 -6.474416, 60.585858 -5.423433, 60.547602 -5.423433))' } }
         *   ]
         *  },
         *  property: 'temperature',
         *  aggregates: ['min', 'max', 'average'],
         *  groupBy: ['category']
         * };
         *
         * const featureStream = await client.geospatial.feature.searchStream('ocean_temperature', aggregateParams);
         * ```
         */
        _this.aggregate = function (featureTypeExternalId, params) {
            return _this.aggregateEndpoint(params, _this.url(featureTypeExternalId + "/features/aggregate"));
        };
        /**
         * [List features](https://docs.cognite.com/api/v1/#tag/Geospatial/operation/listFeatures)
         *
         * ```js
         * const params = {
         *  filter: {
         *    and: [
         *      { range:{ property: 'temperature', gt:4.54 } },
         *      { stWithin: { property:'location', value:'POLYGON((60.547602 -5.423433, 60.547602 -6.474416, 60.585858 -5.423433, 60.547602 -5.423433))' } }
         *   ]
         *  },
         * };
         *
         * const allFeaturesList = await client.geospatial.feature.list('ocean_temperature', params);
         * ```
         */
        _this.list = function (featureTypeExternalId, filterParams) {
            if (filterParams === void 0) { filterParams = {}; }
            var path = _this.url(featureTypeExternalId + "/features/list");
            return _this.listEndpoint(function (params) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.post(path, { data: params })];
            }); }); }, filterParams);
        };
        return _this;
    }
    return FeatureAPI;
}(sdkCore.BaseResourceAPI));

var FeatureTypeAPI = /** @class */ (function (_super) {
    __extends(FeatureTypeAPI, _super);
    function FeatureTypeAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create feature types](https://docs.cognite.com/api/v1/#operation/createFeatureTypes)
         *
         * ```js
         * const featureTypes = [
         *   {
         *      externalId: 'ocean_temperature',
         *      properties: { temperature: { type: 'DOUBLE' as const }, location: { type: 'POINT' as const, srid: 4326 } } ,
         *      searchSpec: { location_idx: { properties : ['location'] } }
         *   }
         * ];
         * const createdFeatureTypes = await client.geospatial.featureType.create(featureTypes);
         * ```
         */
        _this.create = function (featureTypes) {
            return _this.createEndpoint(featureTypes);
        };
        /**
         * [Retrieve feature types](https://docs.cognite.com/api/v1/#operation/getFeatureTypesByIds)
         *
         * ```js
         * const retrievedFeatureTypes = await client.geospatial.featureType.retrieve([ { externalId: 'ocean_temperature' } ]);
         * ```
         */
        _this.retrieve = function (externalIds) {
            return _this.retrieveEndpoint(externalIds);
        };
        /**
         * [List feature types](https://docs.cognite.com/api/v1/#operation/listFeatureTypes)
         *
         * ```js
         * const allFeatureTypes = await client.geospatial.featureType.list();
         * ```
         */
        _this.list = function () {
            return _this.listEndpoint(_this.callListEndpointWithPost);
        };
        /**
         * [Delete feature types](https://docs.cognite.com/api/v1/#operation/GeospatialDeleteFeatureTypes)
         *
         * ```js
         * await client.geospatial.featureType.delete([{ externalId: 'ocean_temperature'}], { recursive : true });
         * ```
         */
        _this.delete = function (externalIds, params) {
            if (params === void 0) { params = {}; }
            return _this.deleteEndpoint(externalIds, params);
        };
        /**
         * [Update feature types](https://docs.cognite.com/api/v1/#operation/updateFeatureTypes)
         *
         * ```js
         * const featureTypesToUpdate = [
         *  {
         *    externalId: 'ocean_temperature',
         *    update: {
         *        properties: { add: { depth: { type: 'DOUBLE'} }, remove: ['temperature'] },
         *        searchSpec: { add: { depth_idx: { properties: ['depth'] } } }
         *    }
         *  }
         * ];
         * const updatedFeatureTypes = await client.geospatial.featureType.update(featureTypesToUpdate);
         * ```
         */
        _this.update = function (changes) {
            return _this.updateEndpoint(changes);
        };
        return _this;
    }
    return FeatureTypeAPI;
}(sdkCore.BaseResourceAPI));

var GeospatialAPI = /** @class */ (function (_super) {
    __extends(GeospatialAPI, _super);
    function GeospatialAPI() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        var _a = __read(args, 3), httpClient = _a[1], map = _a[2];
        _this.computeAPI = new ComputeAPI(_this.url('compute'), httpClient, map);
        _this.crsAPI = new CrsAPI(_this.url('crs'), httpClient, map);
        _this.featureTypeAPI = new FeatureTypeAPI(_this.url('featuretypes'), httpClient, map);
        _this.featureAPI = new FeatureAPI(_this.url('featuretypes'), httpClient, map);
        return _this;
    }
    Object.defineProperty(GeospatialAPI.prototype, "compute", {
        get: function () {
            return this.computeAPI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeospatialAPI.prototype, "crs", {
        get: function () {
            return this.crsAPI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeospatialAPI.prototype, "feature", {
        get: function () {
            return this.featureAPI;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GeospatialAPI.prototype, "featureType", {
        get: function () {
            return this.featureTypeAPI;
        },
        enumerable: false,
        configurable: true
    });
    return GeospatialAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var GroupsAPI = /** @class */ (function (_super) {
    __extends(GroupsAPI, _super);
    function GroupsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create groups](https://doc.cognitedata.com/api/v1/#operation/createGroups)
         *
         * ```js
         * const createdGroups = await client.groups.create([{
         *   name: 'Developers',
         *   capabilities: [{
         *     assetsAcl: {
         *       actions: ['READ'],
         *       scope: { all: {}}
         *     }
         *   }],
         * }]);
         * ```
         */
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        /**
         * [List groups](https://doc.cognitedata.com/api/v1/#operation/getGroups)
         *
         * ```js
         * const groups = await client.groups.list({ all: true });
         * ```
         */
        _this.list = function (scope) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url();
                        return [4 /*yield*/, this.get(path, {
                                params: scope,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        }); };
        /**
         * [Delete groups](https://doc.cognitedata.com/api/v1/#operation/deleteGroups)
         *
         * ```js
         * await client.groups.delete([921923342342323, 871621872721323]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        /**
         * [List service accounts in a group](https://doc.cognitedata.com/api/v1/#operation/getMembersOfGroups)
         *
         * ```js
         * const serviceAccounts = await client.groups.listServiceAccounts(921923342342323);
         * ```
         */
        _this.listServiceAccounts = function (groupId) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeServiceAccountUrl(groupId);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        }); };
        /**
         * [Add service accounts to a group](https://doc.cognitedata.com/api/v1/#operation/addServiceAccountsToGroup)
         *
         * ```js
         * await client.groups.addServiceAccounts(921923342342323, [123312763989213, 23232789217132]);
         * ```
         */
        _this.addServiceAccounts = function (groupId, serviceAccountIds) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeServiceAccountUrl(groupId);
                        return [4 /*yield*/, this.post(path, {
                                data: { items: serviceAccountIds },
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn({}, response)];
                }
            });
        }); };
        /**
         * [Remove service accounts from a group](https://doc.cognitedata.com/api/v1/#operation/removeServiceAccountsFromGroup)
         *
         * ```js
         * await client.groups.removeServiceAccounts(921923342342323, [123312763989213, 23232789217132]);
         * ```
         */
        _this.removeServiceAccounts = function (groupId, serviceAccountIds) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeServiceAccountUrl(groupId) + "/remove";
                        return [4 /*yield*/, this.post(path, {
                                data: { items: serviceAccountIds },
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn({}, response)];
                }
            });
        }); };
        _this.encodeServiceAccountUrl = function (groupId) {
            return _this.url(groupId + "/serviceaccounts");
        };
        return _this;
    }
    /**
     * @hidden
     */
    GroupsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['deletedTime']);
    };
    return GroupsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var InstancesAPI = /** @class */ (function (_super) {
    __extends(InstancesAPI, _super);
    function InstancesAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Search instances](https://developer.cognite.com/api#tag/Instances/operation/searchInstances)
         *
         * ```js
         *  const response = await client.instances.search({
         *    view: {
         *      externalId: 'Describable',
         *      space: 'cdf_core',
         *      type: 'view',
         *      version: 'v1',
         *    },
         *    query: 'your_query',
         *    filter: {
         *      equals: {
         *        property: ['title'],
         *         value: 'your title',
         *      },
         *    },
         *    limit: 1000,
         *  });
         * ```
         */
        _this.search = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.searchUrl, {
                            data: params,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [List instances](https://developer.cognite.com/api#tag/Instances/operation/advancedListInstance)
         *
         * ```js
         *  const response = await client.instances.list({
         *    instanceType: 'node',
         *    sources: [{
         *      source: {
         *        externalId: 'Describable',
         *        space: 'cdf_core',
         *        type: 'view',
         *        version: 'v1',
         *      },
         *    }],
         *    filter: {
         *      equals: {
         *        property: ['title'],
         *         value: 'your title',
         *      },
         *    },
         *    sort: [
         *      { property: ['title'], direction: 'ascending', nullsFirst: false },
         *    ],
         *    limit: 1000,
         *});
         * ```
         */
        _this.list = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.listPostUrl, {
                            data: params,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Retrieve instances](https://developer.cognite.com/api#tag/Instances/operation/byExternalIdsInstances)
         *
         * ```js
         *  const response = await client.instances.retrieve({
         *    sources: [{ source: {
         *          externalId: 'Describable',
         *          space: 'cdf_core',
         *          type: 'view',
         *          version: 'v1',
         *        }
         *      }],
         *     items: [
         *       {
         *         externalId: "node-external-id",
         *         space: "node-space",
         *         instanceType: 'node',
         *       },
         *     ],
         *   });
         * ```
         */
        _this.retrieve = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.byIdsUrl, {
                            data: params,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Upsert instances](https://developer.cognite.com/api#tag/Instances/operation/applyNodeAndEdges)
         *
         * ```js
         *  await client.instances.upsert({
         *  items: [
         *    {
         *       instanceType: 'node',
         *       externalId: 'node-external-id',
         *       space: 'node-space',
         *       sources: [
         *        {
         *            source: {
         *             externalId: 'Describable',
         *             space: 'cdf_core',
         *             type: 'view',
         *             version: 'v1',
         *          },
         *            properties: {
         *             title: 'node-title',
         *             description: 'node-description',
         *             labels: 'node-labels',
         *           },
         *         },
         *       ],
         *     },
         *   ],
         * });
         * ```
         */
        _this.upsert = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), {
                            data: params,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Delete instances](https://developer.cognite.com/api#tag/Instances/operation/deleteBulk)
         *
         * ```js
         *  await client.instances.delete([
         *      {
         *        instanceType: "node",
         *        externalId: "node-external-id",
         *        space: "node-space",
         *      },
         *    ]);
         * ```
         */
        _this.delete = function (items) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.deleteEndpoint.call(this, items)];
            });
        }); };
        /**
         * [Aggregate instances](https://developer.cognite.com/api#tag/Instances/operation/aggregateInstances)
         *
         * ```js
         *  const response = await client.instances.aggregate({
         *     view: {
         *        externalId: 'Describable',
         *        space: 'cdf_core',
         *        type: 'view',
         *        version: 'v1',
         *     },
         *     groupBy: ['externalId'],
         *     aggregates: [{ count: { property: 'externalId' } }],
         *     filter: {
         *       prefix: {
         *         property: ['title'],
         *         value: 'titl',
         *       },
         *     },
         *     limit: 1,
         *   });
         * ```
         */
        _this.aggregate = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.aggregateUrl, {
                            data: params,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Query instances](https://developer.cognite.com/api#tag/Instances/operation/queryContent)
         *
         * ```js
         *  const response = await client.instances.query({
         *     with: {
         *       result_set_1: {
         *         nodes: {
         *           filter: {
         *             equals: {
         *               property: ['node', 'externalId'],
         *               value: "node-external-id",
         *             },
         *           },
         *         },
         *       },
         *     },
         *     select: {
         *       result_set_1: {},
         *     },
         *   });
         * ```
         */
        _this.query = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url('query'), {
                            data: params,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Sync instances](https://developer.cognite.com/api#tag/Instances/operation/syncContent)
         *
         * ```js
         *  const response = await client.instances.sync({
         *     with: {
         *       result_set_1: {
         *         nodes: {
         *           filter: {
         *             equals: {
         *               property: ['node', 'externalId'],
         *               value: "node-external-id",
         *             },
         *           },
         *         },
         *       },
         *     },
         *     select: {
         *       result_set_1: {},
         *     },
         *   });
         * ```
         */
        _this.sync = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url('sync'), {
                            data: params,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        return _this;
    }
    return InstancesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var LabelsAPI = /** @class */ (function (_super) {
    __extends(LabelsAPI, _super);
    function LabelsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create labels](https://docs.cognite.com/api/v1/#operation/createLabelDefinitions)
         *
         * ```js
         * const labels = [
         *   { externalId: 'PUMP', name: "Pump" },
         *   { externalId: 'ROTATING_EQUIPMENT', name: 'Rotating equipment', description: 'Asset with rotating parts' }
         * ];
         * const createdLabels = await client.labels.create(labels);
         * ```
         */
        _this.create = function (items) {
            return _super.prototype.createEndpoint.call(_this, items);
        };
        /**
         * [List labels](https://docs.cognite.com/api/v1/#operation/listLabels)
         *
         * ```js
         * const labels = await client.labels.list({ filter: { externalIdPrefix: 'Pu'}});
         * ```
         */
        _this.list = function (query) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, query);
        };
        /**
         * [Delete labels](https://doc.cognitedata.com/api/v1/#operation/deleteLabels)
         *
         * ```js
         * await client.labels.delete([{externalId: 'PUMP'}, {externalId: 'VALVE'}]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    LabelsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime']);
    };
    return LabelsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var DataModelsAPI = /** @class */ (function (_super) {
    __extends(DataModelsAPI, _super);
    function DataModelsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Upsert datamodels](https://api-docs.cognite.com/20230101/tag/Data-models/operation/createDataModels)
         *
         * const datamodelDefinition = {
         *   "space": "string",
         *   "externalId": "string",
         *   "name": "string",
         *   "description": "string",
         *   "version": "string",
         *   "views": []
         * }
         *
         * ```js
         *  const response = await client.dataModels.upsert([
         *   datamodelDefinition
         *  ]);
         * ```
         */
        _this.upsert = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Delete data models](https://api-docs.cognite.com/20230101/tag/Data-models/operation/deleteDataModels)
         *
         * ```js
         *  const response = await client.dataModels.delete([{ externalId: "", space: "", version: ""}]);
         *
         * ```
         */
        _this.delete = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.deleteUrl, {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [List data models](https://api-docs.cognite.com/20230101/tag/Data-models/operation/listDataModels)
         *
         * ```js
         *  const response = await client.dataModels.list();
         *
         * ```
         */
        _this.list = function (params) {
            if (params === void 0) { params = { includeGlobal: false }; }
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithGet, params);
        };
        /**
         * [Retrieve data models](https://api-docs.cognite.com/20230101/tag/Data-models/operation/byExternalIdsDataModels)
         *
         * ```js
         *  const response = await client.dataModels.retrieve([{ externalId: "", space: "", version: "optional"}]);
         *
         * ```
         */
        _this.retrieve = function (params, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post(this.byIdsUrl, {
                                data: { items: params },
                                params: __assign({}, options),
                            })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.data];
                    }
                });
            });
        };
        return _this;
    }
    return DataModelsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var ProjectsAPI = /** @class */ (function (_super) {
    __extends(ProjectsAPI, _super);
    function ProjectsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Retrieve a project](https://doc.cognitedata.com/api/v1/#operation/getProject)
         *
         * ```js
         * const projectInfo = await client.projects.retrieve('publicdata');
         * ```
         */
        _this.retrieve = function (projectName) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeUrl(projectName);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Update a project](https://doc.cognitedata.com/api/v1/#operation/putProject)
         *
         * ```js
         * await client.projects.update('new-project-name', {
         *   name: 'New project display name',
         *   defaultGroupId: 123,
         * });
         * ```
         */
        _this.update = function (projectName, replacement) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeUrl(projectName);
                        return [4 /*yield*/, this.put(path, {
                                data: replacement,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Partial update a project](https://docs.cognite.com/api/v1/#operation/updateProject)
         *
         * ```js
         * await client.projects.updateProject('new-project-name', {
         *   update: {
         *     name: {
         *       set: 'New project display name',
         *     }
         *   }
         * })
         * ```
         */
        _this.updateProject = function (projectName, replacement) { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeUrl(projectName) + "/update";
                        return [4 /*yield*/, this.post(path, {
                                data: replacement,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        return _this;
    }
    ProjectsAPI.prototype.encodeUrl = function (projectName) {
        return this.url("projects/" + encodeURIComponent(projectName));
    };
    return ProjectsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var RawRowsAPI = /** @class */ (function (_super) {
    __extends(RawRowsAPI, _super);
    function RawRowsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    RawRowsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['lastUpdatedTime']);
    };
    RawRowsAPI.prototype.insert = function (databaseName, tableName, items, ensureParent) {
        if (ensureParent === void 0) { ensureParent = false; }
        return __awaiter(this, void 0, void 0, function () {
            var path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeUrl(databaseName, tableName) + "/rows";
                        return [4 /*yield*/, this.postInParallelWithAutomaticChunking({
                                path: path,
                                items: items,
                                chunkSize: 5000,
                                queryParams: { ensureParent: ensureParent },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, {}];
                }
            });
        });
    };
    RawRowsAPI.prototype.list = function (databaseName, tableName, scope) {
        var _this = this;
        if (scope === void 0) { scope = {}; }
        var onlyRowKeys = scope.onlyRowKeys, columns = scope.columns, rest = __rest(scope, ["onlyRowKeys", "columns"]);
        var query = rest;
        if (onlyRowKeys) {
            query.columns = ',';
        }
        if (columns) {
            query.columns = columns.join(',');
        }
        var path = this.encodeUrl(databaseName, tableName) + "/rows";
        return _super.prototype.listEndpoint.call(this, function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.get(path, {
                        params: params,
                    })];
            });
        }); }, query);
    };
    RawRowsAPI.prototype.retrieve = function (databaseName, tableName, rowKey) {
        return __awaiter(this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeUrl(databaseName, tableName) + "/rows/" + encodeURIComponent(rowKey);
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        });
    };
    RawRowsAPI.prototype.delete = function (databaseName, tableName, items) {
        return __awaiter(this, void 0, void 0, function () {
            var path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeUrl(databaseName, tableName) + "/rows/delete";
                        return [4 /*yield*/, this.postInParallelWithAutomaticChunking({ path: path, items: items })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, {}];
                }
            });
        });
    };
    RawRowsAPI.prototype.encodeUrl = function (databaseName, tableName) {
        return this.url(encodeURIComponent(databaseName) + "/tables/" + encodeURIComponent(tableName));
    };
    return RawRowsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var RawTablesAPI = /** @class */ (function (_super) {
    __extends(RawTablesAPI, _super);
    function RawTablesAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RawTablesAPI.prototype.create = function (databaseName, items, ensureParent) {
        if (ensureParent === void 0) { ensureParent = false; }
        return __awaiter(this, void 0, void 0, function () {
            var path, responses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.encodeUrl(databaseName) + "/tables";
                        return [4 /*yield*/, this.postInParallelWithAutomaticChunking({
                                queryParams: { ensureParent: ensureParent },
                                items: items,
                                path: path,
                            })];
                    case 1:
                        responses = _a.sent();
                        return [2 /*return*/, this.mergeItemsFromItemsResponse(responses)];
                }
            });
        });
    };
    RawTablesAPI.prototype.list = function (databaseName, scope) {
        var _this = this;
        var path = this.encodeUrl(databaseName) + "/tables";
        return _super.prototype.listEndpoint.call(this, function (params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.get(path, {
                        params: params,
                    })];
            });
        }); }, scope);
    };
    RawTablesAPI.prototype.delete = function (databaseName, items) {
        var path = this.encodeUrl(databaseName) + "/tables/delete";
        return this.deleteEndpoint(items, {}, path);
    };
    RawTablesAPI.prototype.encodeUrl = function (databaseName) {
        return this.url("" + encodeURIComponent(databaseName));
    };
    return RawTablesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var RawAPI = /** @class */ (function (_super) {
    __extends(RawAPI, _super);
    /** @hidden */
    function RawAPI(resourcePath, httpClient, map) {
        var _this = _super.call(this, resourcePath, httpClient, map) || this;
        /**
         * [Create databases](https://doc.cognitedata.com/api/v1/#operation/createDBs)
         *
         * ```js
         * const databases = await client.raw.createDatabases([{ name: 'My company' }]);
         * ```
         */
        _this.createDatabases = function (items) {
            return _super.prototype.createEndpoint.call(_this, items);
        };
        /**
         * [List databases](https://doc.cognitedata.com/api/v1/#operation/getDBs)
         *
         * ```js
         * const databases = await client.raw.listDatabases();
         * ```
         */
        _this.listDatabases = function (scope) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithGet, scope);
        };
        /**
         * [Delete databases](https://doc.cognitedata.com/api/v1/#operation/deleteDBs)
         *
         * ```js
         * await client.raw.deleteDatabases([{ name: 'My company' }]);
         * ```
         */
        _this.deleteDatabases = function (items, params) {
            return _super.prototype.deleteEndpoint.call(_this, items, params);
        };
        /**
         * [Create tables in a database](https://doc.cognitedata.com/api/v1/#operation/createTables)
         *
         * ```js
         * const tables = await client.raw.createTables('My company', [{ name: 'Customers' }]);
         * ```
         */
        _this.createTables = function (databaseName, items, ensureParent) {
            if (ensureParent === void 0) { ensureParent = false; }
            return _this.rawTablesApi.create(databaseName, items, ensureParent);
        };
        /**
         * [List tables in database](https://doc.cognitedata.com/api/v1/#operation/getTables)
         *
         * ```js
         * const tables = await client.raw.listTables('My company');
         * ```
         */
        _this.listTables = function (databaseName, scope) {
            return _this.rawTablesApi.list(databaseName, scope);
        };
        /**
         * [Delete tables in a database](https://doc.cognitedata.com/api/v1/#operation/deleteTables)
         *
         * ```js
         * await client.raw.deleteTables('My company', [{ name: 'Customers' }]);
         * ```
         */
        _this.deleteTables = function (databaseName, items) {
            return _this.rawTablesApi.delete(databaseName, items);
        };
        /**
         * [Insert rows into a table](https://doc.cognitedata.com/api/v1/#operation/postRows)
         *
         * ```js
         * await client.raw.insertRows('My company', 'Customers', [{ key: 'customer1', columns: { 'First name': 'Steve', 'Last name': 'Jobs' } }]);
         * ```
         */
        _this.insertRows = function (databaseName, tableName, items, ensureParent) {
            if (ensureParent === void 0) { ensureParent = false; }
            return _this.rawRowsApi.insert(databaseName, tableName, items, ensureParent);
        };
        /**
         * [List rows in a table](https://doc.cognitedata.com/api/v1/#operation/getRows)
         *
         * ```js
         * await client.raw.listRows('My company', 'Employees', { columns: ['last_name'] });
         * ```
         */
        _this.listRows = function (databaseName, tableName, query) {
            return _this.rawRowsApi.list(databaseName, tableName, query);
        };
        /**
         * [Retrieve a single row from a table](https://doc.cognitedata.com/api/v1/#operation/getRow)
         *
         * ```js
         * await client.raw.retrieveRow('My company', 'Customers', 'customer1');
         * ```
         */
        _this.retrieveRow = function (databaseName, tableName, rowKey) {
            return _this.rawRowsApi.retrieve(databaseName, tableName, rowKey);
        };
        /**
         * [Delete rows in a table](https://doc.cognitedata.com/api/v1/#operation/deleteRows)
         *
         * ```js
         * await client.raw.deleteRows('My company', 'Customers', [{key: 'customer1'}]);
         * ```
         */
        _this.deleteRows = function (databaseName, tableName, items) {
            return _this.rawRowsApi.delete(databaseName, tableName, items);
        };
        _this.rawTablesApi = new RawTablesAPI(resourcePath, httpClient, map);
        _this.rawRowsApi = new RawRowsAPI(resourcePath, httpClient, map);
        return _this;
    }
    return RawAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var RelationshipsApi = /** @class */ (function (_super) {
    __extends(RelationshipsApi, _super);
    function RelationshipsApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create relationship](https://docs.cognite.com/api/v1/#operation/createRelationships)
         *
         * ```js
         * const relationships = [
         *   {
         *      externalId: 'some_relationship',
         *      sourceExternalId: 'some_source_external_id',
         *      sourceType: 'asset' as const,
         *      targetExternalId: 'some_target_external_id',
         *      targetType: 'event' as const
         *   }
         * ];
         * const createdRelationships = await client.relationships.create(relationships);
         * ```
         */
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        /**
         * [List relationships](https://docs.cognite.com/api/v1/#operation/listRelationships)
         *
         * ```js
         * const relationships = await client.relationships.list({ filter: { createdTime: { min: new Date('1 jan 2018'), max: new Date('1 jan 2019') }}});
         * ```
         */
        _this.list = function (query) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, query);
        };
        /**
         * [Retrieve relationships](https://docs.cognite.com/api/v1/#operation/byidsRelationships)
         *
         * ```js
         * const relationships = await client.relationships.retrieve([{externalId: 'abc'}, {externalId: 'def'}]);
         * ```
         */
        _this.retrieve = function (ids, params) {
            if (params === void 0) { params = {}; }
            return _super.prototype.retrieveEndpoint.call(_this, ids, params);
        };
        /**
         * [Delete relationships](https://doc.cognitedata.com/api/v1/#operation/deleteRelationships)
         *
         * ```js
         * await client.relationships.delete([{externalId: 'abc'}, {externalId: 'def'}]);
         * ```
         */
        _this.delete = function (ids, params) {
            if (params === void 0) { params = {}; }
            return _super.prototype.deleteEndpoint.call(_this, ids, params);
        };
        return _this;
    }
    /**
     * @hidden
     */
    RelationshipsApi.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    return RelationshipsApi;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var SecurityCategoriesAPI = /** @class */ (function (_super) {
    __extends(SecurityCategoriesAPI, _super);
    function SecurityCategoriesAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create security categories](https://doc.cognitedata.com/api/v1/#operation/createSecurityCategories)
         *
         * ```js
         * const securityCategories = [
         *   { name: 'Admins' },
         *   { name: 'Developers' },
         * ];
         * const createdSecurityCategories = await client.securityCategories.create(securityCategories);
         * ```
         */
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        /**
         * [List security categories](https://doc.cognitedata.com/api/v1/#operation/getSecurityCategories)
         *
         * ```js
         * const securityCategories = await client.securityCategories.list({ sort: 'ASC' });
         * ```
         */
        _this.list = function (query) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithGet, query);
        };
        /**
         * [Delete security categories](https://doc.cognitedata.com/api/v1/#operation/deleteSecurityCategories)
         *
         * ```js
         * await client.securityCategories.delete([123, 456]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        return _this;
    }
    return SecurityCategoriesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var SequenceRowsAPI = /** @class */ (function (_super) {
    __extends(SequenceRowsAPI, _super);
    function SequenceRowsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SequenceRowsAPI.prototype.insert = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postInParallelWithAutomaticChunking({
                            path: this.url(),
                            items: items,
                            chunkSize: 10000,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, {}];
                }
            });
        });
    };
    SequenceRowsAPI.prototype.retrieve = function (query) {
        var _this = this;
        return _super.prototype.listEndpoint.call(this, function (data) {
            return _this.post(_this.listPostUrl, { data: data }).then(_this.transformRetrieveResponse);
        }, query);
    };
    SequenceRowsAPI.prototype.delete = function (items) {
        return this.deleteEndpoint(items);
    };
    SequenceRowsAPI.prototype.transformRetrieveResponse = function (response) {
        var _a = response.data, rows = _a.rows, nextCursor = _a.nextCursor, columns = _a.columns;
        var items = rows.map(function (_a) {
            var rowNumber = _a.rowNumber, values = _a.values;
            return {
                columns: columns,
                rowNumber: rowNumber,
                values: values,
            };
        });
        return __assign(__assign({}, response), { data: {
                items: items,
                nextCursor: nextCursor,
            } });
    };
    return SequenceRowsAPI;
}(sdkCore.BaseResourceAPI));

var SequencesAPI = /** @class */ (function (_super) {
    __extends(SequencesAPI, _super);
    /** @hidden */
    function SequencesAPI(resourcePath, httpClient, map) {
        var _this = _super.call(this, resourcePath, httpClient, map) || this;
        /**
         * [Create sequences](https://docs.cognite.com/api/v1/#operation/createSequence)
         *
         * ```js
         * const sequences = [
         *  {
         *   externalId: 'sequence_name',
         *   columns: [
         *    {
         *      externalId: 'one',
         *      valueType: SequenceValueType.LONG,
         *    },
         *    {
         *      externalId: 'two',
         *    },
         *    {
         *      externalId: 'three',
         *      valueType: SequenceValueType.STRING,
         *    }
         *   ]
         *  }
         * ];
         * const [sequence] = await client.sequences.create(sequences);
         * ```
         */
        _this.create = function (items) {
            return _super.prototype.createEndpoint.call(_this, items);
        };
        /**
         * [List sequences](https://docs.cognite.com/api/v1/#operation/advancedListSequences)
         * <!-- or [similar](https://docs.cognite.com/api/v1/#operation/listSequences) -->
         *
         * ```js
         * const sequences = await client.sequences.list({ filter: { name: 'sequence_name' } });
         * ```
         */
        _this.list = function (scope) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, scope);
        };
        /**
         * [Aggregate sequences](https://docs.cognite.com/api/v1/#operation/aggregateSequences)
         *
         * ```js
         * const aggregates = await client.sequences.aggregate({ filter: { name: "Well" } });
         * console.log('Number of sequences named Well: ', aggregates[0].count)
         * ```
         */
        _this.aggregate = function (query) {
            return _super.prototype.aggregateEndpoint.call(_this, query);
        };
        /**
         * [Retrieve sequences](https://docs.cognite.com/api/v1/#operation/getSequenceById)
         *
         * ```js
         * const [sequence1, sequence2] = await client.sequences.retrieve([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.retrieve = function (ids, params) {
            if (params === void 0) { params = {}; }
            return _super.prototype.retrieveEndpoint.call(_this, ids, params);
        };
        /**
         * [Update sequences](https://docs.cognite.com/api/v1/#operation/updateSequences)
         *
         * ```js
         * const [updatedSequence] = await client.sequences.update([{id: 123, update: {name: {set: 'New name'}}}]);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        /**
         * [Search sequences](https://docs.cognite.com/api/v1/#operation/searchSequences)
         *
         * ```js
         * const sequences = await client.sequences.search({
         *   filter: {
         *     assetIds: [1, 2]
         *   },
         *   search: {
         *     query: 'n*m* desc*ion'
         *   }
         * });
         * ```
         */
        _this.search = function (query) {
            return _super.prototype.searchEndpoint.call(_this, query);
        };
        /**
         * [Delete sequences](https://docs.cognite.com/api/v1/#operation/deleteSequences)
         *
         * ```js
         * await client.sequences.delete([{id: 123}, {externalId: 'abc'}]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        /**
         * [Insert rows](https://docs.cognite.com/api/v1/#operation/postSequenceData)
         *
         * ```js
         *
         * const rows = [
         *  { rowNumber: 0, values: [1, 2.2, 'three'] },
         *  { rowNumber: 1, values: [4, 5, 'six'] }
         * ];
         * await client.sequences.insertRows([{ id: 123, rows, columns: ['one', 'two', 'three'] }]);
         * ```
         */
        _this.insertRows = function (items) {
            return _this.sequenceRowsAPI.insert(items);
        };
        /**
         * [Retrieve rows](https://docs.cognite.com/api/v1/#operation/getSequenceData)
         *
         * ```js
         * const rows = await client.sequences.retrieveRows({ externalId: 'sequence1' }).autoPagingToArray({ limit: 100 });
         * ```
         */
        _this.retrieveRows = function (query) {
            return _this.sequenceRowsAPI.retrieve(query);
        };
        /**
         * [Delete rows](https://docs.cognite.com/api/v1/#operation/deleteSequenceData)
         *
         * ```js
         * await client.sequences.deleteRows([{ id: 32423849, rows: [1,2,3] }]);
         * ```
         */
        _this.deleteRows = function (query) {
            return _this.sequenceRowsAPI.delete(query);
        };
        _this.sequenceRowsAPI = new SequenceRowsAPI(_this.url() + "data", httpClient, map);
        return _this;
    }
    /**
     * @hidden
     */
    SequencesAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items', 'columns'], ['createdTime', 'lastUpdatedTime']);
    };
    return SequencesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var ServiceAccountsAPI = /** @class */ (function (_super) {
    __extends(ServiceAccountsAPI, _super);
    function ServiceAccountsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create service accounts](https://doc.cognitedata.com/api/v1/#operation/createServiceAccounts)
         *
         * ```js
         * const serviceAccounts = [
         *   { name: 'Data extractor' },
         *   { name: 'Monitor', groups: [123, 456] },
         * ];
         * const createdServiceAccounts = await client.serviceAccounts.create(serviceAccounts);
         * ```
         */
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        /**
         * [List all service accounts](https://doc.cognitedata.com/api/v1/#operation/getServiceAccounts)
         *
         * ```js
         * const serviceaccounts = await client.serviceAccounts.list();
         * ```
         */
        _this.list = function () { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url();
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data.items, response)];
                }
            });
        }); };
        /**
         * [Delete service accounts](https://doc.cognitedata.com/api/v1/#operation/deleteServiceAccounts)
         *
         * ```js
         * await client.serviceAccounts.delete([123, 456]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        return _this;
    }
    /**
     * @hidden
     */
    ServiceAccountsAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['deletedTime']);
    };
    return ServiceAccountsAPI;
}(sdkCore.BaseResourceAPI));

var SessionsApi = /** @class */ (function (_super) {
    __extends(SessionsApi, _super);
    function SessionsApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create a session](https://api-docs.cognite.com/20230101/tag/Sessions/operation/createSessions)
         *
         * ```js
         * client.sessions.create([{ clientId: 'client-id', clientSecret: 'client-secret' }])
         * ```
         * */
        _this.create = function (items) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), { data: { items: items } })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.items];
                }
            });
        }); };
        /**
         * [List sessions](https://api-docs.cognite.com/20230101/tag/Sessions/operation/listSessions)
         *
         * ```js
         * client.sessions.list({ filter: { status: 'ACTIVE' } })
         * ```
         */
        _this.list = function (query) {
            var _a = query || {}, filter = _a.filter, rest = __rest(_a, ["filter"]);
            return _this.listEndpoint(_this.callListEndpointWithGet, __assign(__assign({}, rest), filter));
        };
        /**
         * [Retrieve sessions with given IDs](https://api-docs.cognite.com/20230101/tag/Sessions/operation/getSessionsByIds)
         *
         * ```js
         * client.sessions.retrieve([{ id: 1 }])
         * ```
         */
        _this.retrieve = function (ids) {
            return _this.retrieveEndpoint(ids);
        };
        return _this;
    }
    /**
     * [Revoke access to a session](https://api-docs.cognite.com/20230101/tag/Sessions/operation/revokeSessions)
     *
     * ```js
     * client.sessions.revoke([{ id: 1 }])
     * ```
     */
    SessionsApi.prototype.revoke = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url('revoke');
                        return [4 /*yield*/, this.post(url, {
                                data: { items: ids },
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data.items];
                }
            });
        });
    };
    return SessionsApi;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var SpacesAPI = /** @class */ (function (_super) {
    __extends(SpacesAPI, _super);
    function SpacesAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Upsert spaces](https://api-docs.cognite.com/20230101/tag/Spaces/operation/ApplySpaces)
         *
         * const spaceDefinition = {
         *    space: 'my_space',
         *    name: 'my_space',
         *    description: 'My space for data',
         *   };
         *
         * ```js
         *  const response = await client.spaces.upsert([
         *   spaceDefinition
         *  ]);
         * ```
         */
        _this.upsert = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Delete spaces](https://api-docs.cognite.com/20230101/tag/Spaces/operation/deleteSpacesV3)
         *
         * ```js
         *  const response = await client.instances.delete(["my_space"]);
         *
         * ```
         */
        _this.delete = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.deleteUrl, {
                            data: { items: params.map(function (space) { return ({ space: space }); }) },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [List spaces](https://api-docs.cognite.com/20230101/tag/Spaces/operation/listSpacesV3)
         *
         * ```js
         *  const response = await client.instances.list(["my_space"]);
         *
         * ```
         */
        _this.list = function (params) {
            if (params === void 0) { params = { includeGlobal: false }; }
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithGet, params);
        };
        /**
         * [Retrieve spaces](https://api-docs.cognite.com/20230101/tag/Spaces/operation/bySpaceIdsSpaces)
         *
         * ```js
         *  const response = await client.instances.retrieve(["my_space"]);
         *
         * ```
         */
        _this.retrieve = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.byIdsUrl, {
                            data: { items: params.map(function (space) { return ({ space: space }); }) },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        return _this;
    }
    return SpacesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var TemplateGraphQlApi = /** @class */ (function (_super) {
    __extends(TemplateGraphQlApi, _super);
    function TemplateGraphQlApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Run a GraphQL query](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsVersionGraphql)
         *
         * ```js
         * client.templates.group("myGroup").versions(1).runQuery({ query: `
         *   wellList {
         *     name
         *   }
         * `});
         * ```
         */
        _this.runQuery = function (_a) {
            var query = _a.query, variables = _a.variables, operationName = _a.operationName;
            return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.post(this.url(), {
                                data: {
                                    query: query,
                                    variables: variables,
                                    operationName: operationName,
                                },
                            })];
                        case 1:
                            res = _b.sent();
                            return [2 /*return*/, res.data];
                    }
                });
            });
        };
        return _this;
    }
    return TemplateGraphQlApi;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var TemplateGroupVersionsApi = /** @class */ (function (_super) {
    __extends(TemplateGroupVersionsApi, _super);
    function TemplateGroupVersionsApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Upsert a Template Group version](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsUpsert)
      Create or update a Template Group version.
         *
         * ```js
         * const version = { schema: "type MyType @template { someField: String }", conflictMode: ConflictMode.Patch };
         * const newVersion = await client.group("myGroup").versions.upsert(version);
         * ```
         */
        _this.upsert = function (item) {
            return _this.post(_this.url('upsert'), {
                data: item,
            }).then(function (res) { return res.data; });
        };
        /**
         * [List Template Group versions](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsList)
         *
         * ```js
         * const versions = await client.templates.group("myGroup").versions.list( { minVersion: 1, maxVersion: 4 } );
         * ```
         */
        _this.list = function (query) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, query);
        };
        /**
         * [Delete a Template Group version](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsDelete)
         *
         * ```js
         * await client.templates.group("myGroup").versions.delete(1);
         * ```
         */
        _this.delete = function (version) {
            return _this.post(_this.url('delete'), {
                data: {
                    version: version,
                },
            });
        };
        return _this;
    }
    return TemplateGroupVersionsApi;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var TemplateGroupsApi = /** @class */ (function (_super) {
    __extends(TemplateGroupsApi, _super);
    function TemplateGroupsApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create Template Groups](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroups)
         *
         * ```js
         * const templateGroups = [
         *   { externalId: 'Wells', description: 'Models a Well system', owners: ['user.name@example.com'] },
         * ];
         * const createdTemplateGroups = await client.templates.groups.create(templateGroups);
         * ```
         */
        _this.create = function (items) {
            return _super.prototype.createEndpoint.call(_this, items);
        };
        /**
         * [Upsert Template Groups](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsUpsert)
         *
         * ```js
         * const templateGroups = [
         *   { externalId: 'Wells', description: 'Models a Well system', owners: ['user.name@example.com'] },
         * ];
         * const upsertedTemplateGroups = await client.templates.groups.upsert(templateGroups);
         * ```
         */
        _this.upsert = function (items) {
            return _super.prototype.createEndpoint.call(_this, items, _this.url('upsert'));
        };
        /**
         * [Retrieve Template Groups](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsByids)
         *
         * ```js
         * const templateGroups = await client.templates.groups.retrieve([{externalId: 'abc'}]);
         * ```
         */
        _this.retrieve = function (ids, options) {
            return _super.prototype.retrieveEndpoint.call(_this, ids, options || { ignoreUnknownIds: false });
        };
        /**
         * [List Template Groups](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsList)
         *
         * ```js
         * const templateGroups = await client.templates.groups.list({ filter: { owners: ["user.name@example.com"] } });
         * ```
         */
        _this.list = function (query) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, query);
        };
        /**
         * [Delete Template Groups](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsDelete)
         *
         * ```js
         * await client.templates.groups.delete([{ externalId: "Wells" }]);
         * ```
         */
        _this.delete = function (ids, options) {
            return _super.prototype.deleteEndpoint.call(_this, ids, options || {
                ignoreUnknownIds: false,
            });
        };
        return _this;
    }
    return TemplateGroupsApi;
}(sdkCore.BaseResourceAPI));

var SessionStatus = {
    READY: 'READY',
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
    REVOKED: 'REVOKED',
    ACCESS_LOST: 'ACCESS_LOST',
};
var SessionType = {
    CLIENT_CREDENTIALS: 'CLIENT_CREDENTIALS',
    TOKEN_EXCHANGE: 'TOKEN_EXCHANGE',
    ONESHOT_TOKEN_EXCHANGE: 'ONESHOT_TOKEN_EXCHANGE',
};

// Copyright 2020 Cognite AS
function isManagedInCDFGroup(group) {
    return group.members !== undefined;
}
function isManagedExternallyGroup(group) {
    return !isManagedInCDFGroup(group);
}
var SequenceValueType = {
    STRING: 'STRING',
    DOUBLE: 'DOUBLE',
    LONG: 'LONG',
};
var SortOrder = {
    ASC: 'asc',
    DESC: 'desc',
};
var ContextJobStatus = {
    QUEUED: 'QUEUED',
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
};
var EntityMatchingFeatureType = {
    SIMPLE: 'simple',
    BIGRAM: 'bigram',
    FREQUENCY_WEIGHTED_BIGRAM: 'frequencyweightedbigram',
    BIGRAM_EXTRA_TOKENIZERS: 'bigramextratokenizers',
    BIGRAM_COMBO: 'bigramcombo',
};
var EntityMatchingClassifier = {
    RANDOM_FOREST: 'randomforest',
    DECISION_TREE: 'decisiontree',
    LOGISTIC_REGRESSION: 'logisticregression',
    AUGMENTED_LOGISTIC_REGRESSION: 'augmentedlogisticregression',
    AUGMENTED_RANDOM_FOREST: 'augmentedrandomforest',
};
(function (ConflictMode) {
    /** Patch the existing version, but will fail if there are breaking changes. */
    ConflictMode["Patch"] = "Patch";
    /** Update the Template Group by bumping the version. */
    ConflictMode["Update"] = "Update";
    /** Force update the existing version even if there are breaking changes. Note, this can break consumers of that version. */
    ConflictMode["Force"] = "Force";
})(exports.ConflictMode || (exports.ConflictMode = {}));
var ConstantResolver = /** @class */ (function () {
    function ConstantResolver(value) {
        this.type = 'constant';
        this.value = value;
    }
    return ConstantResolver;
}());
var RawResolver = /** @class */ (function () {
    function RawResolver(dbName, tableName, rowKey, columnName) {
        this.type = 'raw';
        this.dbName = dbName;
        this.tableName = tableName;
        this.rowKey = rowKey;
        this.columnName = columnName;
    }
    return RawResolver;
}());
var SyntheticTimeSeriesResolver = /** @class */ (function () {
    function SyntheticTimeSeriesResolver(expression, name, metadata, description, isStep, isString, unit) {
        this.type = 'syntheticTimeSeries';
        this.expression = expression;
        this.name = name;
        this.metadata = metadata;
        this.description = description;
        this.isStep = isStep;
        this.isString = isString;
        this.unit = unit;
    }
    return SyntheticTimeSeriesResolver;
}());
var ViewResolver = /** @class */ (function () {
    function ViewResolver(externalId, input) {
        this.type = 'view';
        this.externalId = externalId;
        this.input = input;
    }
    return ViewResolver;
}());

// Copyright 2020 Cognite AS
var TemplateInstancesApi = /** @class */ (function (_super) {
    __extends(TemplateInstancesApi, _super);
    function TemplateInstancesApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Create Template Instances](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsVersionInstances)
         *
         * ```js
         * const instances = [
         *   { externalId: 'Well_a', templateName: "Well", fieldResolvers: { name: "Underwater P23", pressure: "21_PT19" } },
         *   { externalId: 'Well_b', templateName: "Well", fieldResolvers: { name: "Underwater P01" } },
         * ];
         * const createdInstances = await client.templates.group("myGroup").version(1).create(instances);
         * ```
         */
        _this.create = function (items) {
            return _super.prototype.createEndpoint.call(_this, TemplateInstanceCodec.encodeTemplateInstances(items))
                .then(TemplateInstanceCodec.decodeTemplateInstances);
        };
        /**
         * [Upsert Template Instances](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsVersionInstancesUpsert)
         *
         * ```js
         * const instances = [
         *   { externalId: "Well_a", templateName: "Well", fieldResolvers: { name: "Underwater P23", pressure: "21_PT19" } },
         *   { externalId: "Well_b", templateName: "Well", fieldResolvers: { name: "Underwater P01" } },
         * ];
         * const createdInstances = await client.templates.group("myGroup").version(1).upsert(instances);
         * ```
         */
        _this.upsert = function (items) {
            return _super.prototype.createEndpoint.call(_this, TemplateInstanceCodec.encodeTemplateInstances(items), _this.url('upsert'))
                .then(TemplateInstanceCodec.decodeTemplateInstances);
        };
        /**
         * [Update Template Instances](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsVersionInstancesUpdate)
         *
         * ```js
         * const instances = await client.templates.group("myGroup").version(1).update( [{ update: {
         *   fieldResolvers: {
         *     set: {
         *       myStringField: "My Field"
         *     }
         *   }
         * }, externalId: 'someExtId' }] );
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes.map(TemplateInstanceCodec.encodePatch))
                .then(TemplateInstanceCodec.decodeTemplateInstances);
        };
        /**
         * [Retrieve Template Instances](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsVersionInstancesByids)
         *
         * ```js
         * const instances = await client.templates.group("myGroup").version(1).retrieve([ { externalId: 'Well } ]);
         * ```
         */
        _this.retrieve = function (ids, options) {
            return _super.prototype.retrieveEndpoint.call(_this, ids, options || { ignoreUnknownIds: false })
                .then(TemplateInstanceCodec.decodeTemplateInstances);
        };
        /**
         * [List Template Instances](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsVersionInstancesList)
         *
         * ```js
         * const instances = await client.templates.group("myGroup").version(1).list( { templateNames: ["Well"] } );
         * ```
         */
        _this.list = function (query) {
            return _super.prototype.listEndpoint.call(_this, function (scope) { return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.callListEndpointWithPost(scope)];
                        case 1:
                            res = _a.sent();
                            return [2 /*return*/, __assign(__assign({}, res), { data: __assign(__assign({}, res.data), { items: TemplateInstanceCodec.decodeTemplateInstances(res.data.items) }) })];
                    }
                });
            }); }, query);
        };
        /**
         * [Delete Template Instances](https://pr-1202.specs.preview.cogniteapp.com/v1.json.html#operation/postApiV1ProjectsProjectTemplategroupsExternalidVersionsVersionInstancesDelete)
         *
         * ```js
         * const instances = await client.templates.group("myGroup").version(1).delete([{ externalId: ["Well_a"] }]);
         * ```
         */
        _this.delete = function (ids, options) {
            return _super.prototype.deleteEndpoint.call(_this, ids, options || {
                ignoreUnknownIds: false,
            });
        };
        return _this;
    }
    return TemplateInstancesApi;
}(sdkCore.BaseResourceAPI));
// biome-ignore lint/complexity/noStaticOnlyClass: not worth changing
var TemplateInstanceCodec = /** @class */ (function () {
    function TemplateInstanceCodec() {
    }
    TemplateInstanceCodec.encodeTemplateInstances = function (templateInstances) {
        return templateInstances.map(function (item) {
            return __assign(__assign({}, item), { fieldResolvers: TemplateInstanceCodec.encodeFieldResolvers(item.fieldResolvers) });
        });
    };
    TemplateInstanceCodec.encodePatch = function (patch) {
        return __assign(__assign({}, patch), { update: {
                fieldResolvers: {
                    add: 'add' in patch.update.fieldResolvers
                        ? TemplateInstanceCodec.encodeFieldResolvers(patch.update.fieldResolvers.add)
                        : // biome-ignore lint/style/noNonNullAssertion: couldn't find correct type definition.
                            undefined,
                    remove: 'remove' in patch.update.fieldResolvers
                        ? patch.update.fieldResolvers.remove
                        : // biome-ignore lint/style/noNonNullAssertion: couldn't find correct type definition.
                            undefined,
                    set: 'set' in patch.update.fieldResolvers
                        ? TemplateInstanceCodec.encodeFieldResolvers(patch.update.fieldResolvers.set)
                        : // biome-ignore lint/style/noNonNullAssertion: couldn't find correct type definition.
                            undefined,
                },
            } });
    };
    TemplateInstanceCodec.encodeFieldResolvers = function (fieldResolvers) {
        var mappedResolvers = toPairs(fieldResolvers).map(function (_a) {
            var _b = __read(_a, 2), name = _b[0], fieldResolver = _b[1];
            if (fieldResolver !== undefined &&
                !TemplateInstanceCodec.isFieldResolver(fieldResolver)) {
                // Auto-wrap objects, numbers etc. as ConstantResolver.
                return [name, new ConstantResolver(fieldResolver)];
            }
            return [name, fieldResolver];
        });
        return fromPairs(mappedResolvers);
    };
    TemplateInstanceCodec.decodeTemplateInstances = function (templateInstances) {
        return templateInstances.map(function (item) {
            return __assign(__assign({}, item), { fieldResolvers: TemplateInstanceCodec.decodeFieldResolvers(item.fieldResolvers) });
        });
    };
    TemplateInstanceCodec.decodeFieldResolvers = function (fieldResolvers) {
        var mappedResolvers = toPairs(fieldResolvers).map(function (_a) {
            var _b = __read(_a, 2), name = _b[0], fieldResolver = _b[1];
            return [
                name,
                // biome-ignore lint/suspicious/noExplicitAny: couldn't find correct type definition.
                TemplateInstanceCodec.decodeFieldResolver(fieldResolver),
            ];
        });
        return fromPairs(mappedResolvers);
    };
    // biome-ignore lint/suspicious/noExplicitAny: couldn't find correct type definition.
    TemplateInstanceCodec.decodeFieldResolver = function (fieldResolver) {
        switch (fieldResolver.type) {
            case 'constant':
                return fieldResolver.value;
            case 'raw':
                return new RawResolver(fieldResolver.dbName, fieldResolver.tableName, fieldResolver.rowKey, fieldResolver.columnName);
            case 'syntheticTimeSeries':
                return new SyntheticTimeSeriesResolver(fieldResolver.expression, fieldResolver.name, fieldResolver.metadata, fieldResolver.description, fieldResolver.isStep, fieldResolver.isString, fieldResolver.unit);
            case 'view':
                return new ViewResolver(fieldResolver.externalId, fieldResolver.input);
            default:
                throw new Error('Unknown field resolver type');
        }
    };
    // biome-ignore lint/suspicious/noExplicitAny: couldn't find correct type definition.
    TemplateInstanceCodec.isFieldResolver = function (fieldResolver) {
        return (fieldResolver.type === 'constant' ||
            fieldResolver.type === 'raw' ||
            fieldResolver.type === 'syntheticTimeSeries' ||
            fieldResolver.type === 'view');
    };
    return TemplateInstanceCodec;
}());

var ViewsApi = /** @class */ (function (_super) {
    __extends(ViewsApi, _super);
    function ViewsApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.create = function (items) {
            return _this.createEndpoint(items);
        };
        _this.upsert = function (items) {
            return _this.createEndpoint(items, _this.url('upsert'));
        };
        _this.list = function (query) {
            return _this.listEndpoint(_this.callListEndpointWithPost, query);
        };
        _this.resolve = function (resolveRequest) {
            var resolveFetch = function (filter) { return __awaiter(_this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post(this.url('resolve'), {
                                data: filter || {},
                            })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response];
                    }
                });
            }); };
            return _this.listEndpoint(
            // biome-ignore lint/suspicious/noExplicitAny: didn't manage to type this properly within reasonable time
            resolveFetch, resolveRequest);
        };
        _this.delete = function (ids, options) {
            return _super.prototype.deleteEndpoint.call(_this, ids, options || {
                ignoreUnknownIds: false,
            });
        };
        return _this;
    }
    return ViewsApi;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var SyntheticTimeSeriesAPI = /** @class */ (function (_super) {
    __extends(SyntheticTimeSeriesAPI, _super);
    function SyntheticTimeSeriesAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.query = function (items) {
            return _this.querySyntheticEndpoint(items);
        };
        return _this;
    }
    /**
     * @hidden
     */
    SyntheticTimeSeriesAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items', 'datapoints'], ['timestamp']);
    };
    SyntheticTimeSeriesAPI.prototype.querySyntheticEndpoint = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var path;
            var _this = this;
            return __generator(this, function (_a) {
                path = this.url('query');
                return [2 /*return*/, this.callEndpointWithMergeAndTransform(items, function (data) {
                        return _this.postInParallelWithAutomaticChunking({
                            path: path,
                            items: data,
                            chunkSize: 10,
                        });
                    })];
            });
        });
    };
    return SyntheticTimeSeriesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var TimeSeriesAPI = /** @class */ (function (_super) {
    __extends(TimeSeriesAPI, _super);
    /** @hidden */
    function TimeSeriesAPI(resourcePath) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spread([resourcePath], args)) || this;
        /**
         * [Create time series](https://doc.cognitedata.com/api/v1/#operation/postTimeSeries)
         *
         * ```js
         * const timeseries = [
         *   { name: 'Pressure sensor', assetId: 123 },
         *   { name: 'Temperature sensor', description: 'Pump abc', unit: 'C' },
         * ];
         * const createdTimeseries = await client.timeseries.create(timeseries);
         * ```
         */
        _this.create = function (items) {
            return _super.prototype.createEndpoint.call(_this, items);
        };
        /**
         * [List time series](https://doc.cognitedata.com/api/v1/#operation/getTimeSeries)
         *
         * ```js
         * const timeseries = await client.timeseries.list({ filter: { assetIds: [1, 2] }});
         * ```
         */
        _this.list = function (scope) {
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithPost, scope);
        };
        /**
         * [Aggregate timeseries](https://docs.cognite.com/api/v1/#operation/aggregateTimeSeries)
         *
         * ```js
         * const aggregates = await client.timeseries.aggregate({ filter: { isString: true } });
         * console.log('Number of string timeseries: ', aggregates[0].count)
         * ```
         */
        _this.aggregate = function (query) {
            return _super.prototype.aggregateEndpoint.call(_this, query);
        };
        /**
         * [Retrieve time series](https://doc.cognitedata.com/api/v1/#operation/getTimeSeriesByIds)
         *
         * ```js
         * const timeseries = await client.timeseries.retrieve([
         *   { id: 123 },
         *   { externalId: 'abc' }
         * ]);
         * ```
         */
        _this.retrieve = function (ids, params) {
            if (params === void 0) { params = {}; }
            return _super.prototype.retrieveEndpoint.call(_this, ids, params);
        };
        /**
         * [Update time series](https://doc.cognitedata.com/api/v1/#operation/alterTimeSeries)
         *
         * ```js
         * const timeseries = await client.timeseries.update([{
         *   id: 3785438579439,
         *   update: {
         *     name: { set: 'New name' }
         *   }
         * }]);
         * ```
         */
        _this.update = function (changes) {
            return _super.prototype.updateEndpoint.call(_this, changes);
        };
        /**
         * [Search for time series](https://doc.cognitedata.com/api/v1/#operation/searchTimeSeries)
         *
         * ```js
         * const timeseries = await client.timeseries.search({
         *   filter: {
         *     isString: false,
         *   },
         *   search: {
         *     query: 'Temperature'
         *   }
         * });
         * ```
         */
        _this.search = function (query) {
            return _super.prototype.searchEndpoint.call(_this, query);
        };
        /**
         * [Delete time series](https://doc.cognitedata.com/api/v1/#operation/deleteTimeSeries)
         *
         * ```js
         * await client.timeseries.delete([
         *   { id: 123 },
         *   { externalId: 'abc' }
         * ]);
         * ```
         */
        _this.delete = function (ids) {
            return _super.prototype.deleteEndpoint.call(_this, ids);
        };
        /**
         * [Synthetic Query](https://docs.cognite.com/api/v1/#operation/querySyntheticTimeseries)
         *
         * ```js
         * await client.timeseries.syntheticQuery([
         *   {
         *     expression: "24 * TS{externalId='production/hour', aggregate='average', granularity='1d'}",
         *     start: '48h-ago',
         *     end: 'now',
         *     limit: 100
         *   }
         * ]);
         * ```
         */
        _this.syntheticQuery = function (items) {
            return _this.syntheticTimeseriesApi.query(items);
        };
        _this.syntheticTimeseriesApi = new (SyntheticTimeSeriesAPI.bind.apply(SyntheticTimeSeriesAPI, __spread([void 0, _this.url('synthetic')], args)))();
        return _this;
    }
    /**
     * @hidden
     */
    TimeSeriesAPI.prototype.getDateProps = function () {
        return this.pickDateProps(['items'], ['createdTime', 'lastUpdatedTime']);
    };
    return TimeSeriesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var UnitSystemsAPI = /** @class */ (function (_super) {
    __extends(UnitSystemsAPI, _super);
    function UnitSystemsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.listEndpoint(this.callListEndpointWithGet)];
            });
        }); };
        return _this;
    }
    return UnitSystemsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var UnitsAPI = /** @class */ (function (_super) {
    __extends(UnitsAPI, _super);
    function UnitsAPI() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, __spread(args)) || this;
        /**
         * [List all supported units](https://developer.cognite.com/api#tag/Units/operation/listUnits)
         *
         * ```js
         * const units = await client.units.list();
         * ```
         */
        _this.list = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.listEndpoint(this.callListEndpointWithGet)];
            });
        }); };
        /**
         * [Retrieve one or more units](https://developer.cognite.com/api#tag/Units/operation/byIdsUnits)
         *
         * ```js
         * const units = await client.units.retrieve([{ externalId: 'temperature:deg_c' }, { externalId: 'pressure:bar' }]);
         * ```
         */
        _this.retrieve = function (ids) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.retrieveEndpoint(ids)];
            });
        }); };
        /**
         * [List all supported unit systems](List all supported unit systems <https://developer.cognite.com/api#tag/Unit-Systems/operation/listUnitSystems)
         *
         * ```js
         * const units = await client.units.listUnitSystems();
         * ```
         */
        _this.listUnitSystems = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.unitSystemsApi.list()];
            });
        }); };
        var _a = __read(args, 3), resourcePath = _a[0], client = _a[1], metadataMap = _a[2];
        _this.unitSystemsApi = new UnitSystemsAPI(resourcePath + "/systems", client, metadataMap);
        return _this;
    }
    return UnitsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var ProfilesAPI = /** @class */ (function (_super) {
    __extends(ProfilesAPI, _super);
    function ProfilesAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Get the user profile of the principal issuing the request](https://developer.cognite.com/api#tag/User-profiles/operation/getRequesterUserProfile)
         *
         * ```js
         * const response = await client.profiles.me();
         * ```
         */
        _this.me = function () { return __awaiter(_this, void 0, void 0, function () {
            var path, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url('me');
                        return [4 /*yield*/, this.get(path)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [List all user profiles](https://developer.cognite.com/api#tag/User-profiles/operation/listUserProfiles)
         *
         * ```js
         * const response = await client.profiles.list({ limit: 1000, cursor: 'abc' });
         * ```
         */
        _this.list = function (scope) {
            return _this.listEndpoint(_this.callListEndpointWithGet, scope);
        };
        /**
         * [Retrieve one or more user profiles by ID](https://developer.cognite.com/api#tag/User-profiles/operation/getUserProfilesByIds)
         *
         * ```js
         * const response = await client.profiles.retrieve([{ userIdentifier: 'abcd' }]);
         * ```
         */
        _this.retrieve = function (userIdentifiers) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.retrieveEndpoint.call(this, userIdentifiers)];
            });
        }); };
        /**
         * [Search user profiles](https://developer.cognite.com/api#tag/User-profiles/operation/userProfilesSearch)
         *
         * ```js
         * const response = await client.profiles.search({ search: { name: 'John' } });
         * ```
         */
        _this.search = function (query) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.searchEndpoint.call(this, query)];
            });
        }); };
        return _this;
    }
    return ProfilesAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2023 Cognite AS
var ViewsAPI = /** @class */ (function (_super) {
    __extends(ViewsAPI, _super);
    function ViewsAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Upsert Views](https://api-docs.cognite.com/20230101/tag/Views/operation/ApplyViews)
         *
         * ```js
         * const viewDefinition = {
         *  "externalId": "string",
         *   "space": "string",
         *   "name": "string",
         *   "description": "string",
         *   "filter": {
         *     "and": []
         *   },
         *   "implements": [
         *     {
         *       "type": "view",
         *       "space": "string",
         *       "externalId": "string",
         *       "version": "string"
         *     }
         *   ],
         *   "version": "string",
         *   "properties": {}
         *  };
         *
         *  const response = await client.views.upsert([
         *   viewDefinition
         *  ]);
         * ```
         */
        _this.upsert = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.url(), {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [Delete Views](https://api-docs.cognite.com/20230101/tag/Views/operation/deleteViews)
         *
         * ```js
         *  const response = await client.views.delete([{
         *    space: "my_space",
         *    externalId: "my_external_id",
         *    version: "my_version"
         *  }]);
         *
         * ```
         */
        _this.delete = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post(this.deleteUrl, {
                            data: { items: params },
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        /**
         * [List Views](https://api-docs.cognite.com/20230101/tag/Views/operation/listViews)
         *
         * ```js
         *  const response = await client.views.list();
         *
         * ```
         */
        _this.list = function (params) {
            if (params === void 0) { params = { includeGlobal: false }; }
            return _super.prototype.listEndpoint.call(_this, _this.callListEndpointWithGet, params);
        };
        /**
         * [Retrieve Views](https://api-docs.cognite.com/20230101/tag/Views/operation/byExternalIdsViews)
         *
         * ```js
         *  const response = await client.views.retrieve([
         *  {
         *   space: "my_space",
         *   externalId: "my_external_id",
         *   version: "my_optional_version"
         *  }
         * ]);
         *
         * ```
         */
        _this.retrieve = function (params, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.post(this.byIdsUrl, {
                                data: __assign({ items: params }, options),
                            })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.data];
                    }
                });
            });
        };
        return _this;
    }
    return ViewsAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2022 Cognite AS
var JOB_COMPLETE_STATES = ['Completed', 'Failed'];
/** @hidden */
var BETA_FEATURES = [
    'IndustrialObjectDetection',
    'PersonalProtectiveEquipmentDetection',
];
var VisionAPI = /** @class */ (function (_super) {
    __extends(VisionAPI, _super);
    function VisionAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * [Extract features from image](https://docs.cognite.com/api/v1/#tag/Vision/operation/postVisionExtract)
         *
         * ```js
         * const job = await client.vision.extract(['TextDetection', 'AssetTagDetection', 'PeopleDetection'], [{ fileId: 1234 }]);
         * ```
         */
        _this.extract = function (features, ids, parameters) { return __awaiter(_this, void 0, void 0, function () {
            var path, headers, betaFeatures, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.url('extract');
                        headers = {};
                        betaFeatures = features.filter(function (f) { return BETA_FEATURES.includes(f); });
                        if (betaFeatures.length > 0) {
                            console.warn("Features '" + betaFeatures + "' are in beta and are still in development");
                            headers = __assign(__assign({}, headers), { 'cdf-version': 'beta' });
                        }
                        return [4 /*yield*/, this.post(path, {
                                data: { features: features, items: ids, parameters: parameters },
                                headers: headers,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                }
            });
        }); };
        /**
         * [Retrieve extract job](https://docs.cognite.com/api/v1/#tag/Vision/operation/getVisionExtract)
         *
         * ```js
         * const { items } = await client.vision.getExtractJob(12345678, true); // get an existing job, wait for it to complete, and get the results
         * items.forEach((item) => {
         *  const predictions = item.predictions // do something with the predictions
         * });
         * ```
         */
        _this.getExtractJob = function (jobId, waitForCompletion, pollingTimeMs, maxRetries) {
            if (waitForCompletion === void 0) { waitForCompletion = true; }
            if (pollingTimeMs === void 0) { pollingTimeMs = 1000; }
            if (maxRetries === void 0) { maxRetries = 600; }
            return __awaiter(_this, void 0, void 0, function () {
                var path, getJobResult, isJobCompleted;
                var _this = this;
                return __generator(this, function (_a) {
                    path = this.url("extract/" + jobId);
                    getJobResult = function () { return __awaiter(_this, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.get(path)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, this.addToMapAndReturn(response.data, response)];
                            }
                        });
                    }); };
                    isJobCompleted = function (result) {
                        return JOB_COMPLETE_STATES.includes(result.status);
                    };
                    return [2 /*return*/, waitForCompletion
                            ? this.waitForJobToCompleteAndReturn(getJobResult, isJobCompleted, pollingTimeMs, maxRetries)
                            : getJobResult()];
                });
            });
        };
        return _this;
    }
    VisionAPI.prototype.waitForJobToCompleteAndReturn = function (getJobResult, isJobCompleted, pollingTimeMs, maxRetries) {
        return __awaiter(this, void 0, void 0, function () {
            var retryCount, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retryCount = 0;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, getJobResult()];
                    case 2:
                        result = _a.sent();
                        // Job is in a complete state. We can now exit this loop.
                        if (isJobCompleted(result))
                            return [2 /*return*/, result];
                        // Wait a bit before retrying..
                        return [4 /*yield*/, sdkCore.sleepPromise(pollingTimeMs)];
                    case 3:
                        // Wait a bit before retrying..
                        _a.sent();
                        retryCount++;
                        _a.label = 4;
                    case 4:
                        if (retryCount < maxRetries) return [3 /*break*/, 1];
                        _a.label = 5;
                    case 5: throw new Error('Timed out while waiting for vision job to complete.');
                }
            });
        });
    };
    return VisionAPI;
}(sdkCore.BaseResourceAPI));

// Copyright 2020 Cognite AS
var _a;
var ENDPOINTS_TO_RETRY = (_a = {},
    _a[sdkCore.HttpMethod.Post] = [
        '/assets/list',
        '/assets/byids',
        '/assets/search',
        '/events/list',
        '/events/byids',
        '/events/search',
        '/files/list',
        '/files/byids',
        '/files/search',
        '/files/initupload',
        '/files/downloadlink',
        '/timeseries/byids',
        '/timeseries/search',
        '/timeseries/data',
        '/timeseries/data/list',
        '/timeseries/data/latest',
        '/timeseries/data/delete',
        '/timeseries/synthetic/query',
    ],
    _a);
var retryValidator = sdkCore.createRetryValidator(ENDPOINTS_TO_RETRY);

var CogniteClient = /** @class */ (function (_super) {
    __extends(CogniteClient, _super);
    function CogniteClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CogniteClient.prototype, "assets", {
        get: function () {
            return sdkCore.accessApi(this.assetsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "timeseries", {
        get: function () {
            return sdkCore.accessApi(this.timeSeriesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "datapoints", {
        get: function () {
            return sdkCore.accessApi(this.dataPointsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "sequences", {
        get: function () {
            return sdkCore.accessApi(this.sequencesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "events", {
        get: function () {
            return sdkCore.accessApi(this.eventsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "files", {
        get: function () {
            return sdkCore.accessApi(this.filesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "labels", {
        get: function () {
            return sdkCore.accessApi(this.labelsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "raw", {
        get: function () {
            return sdkCore.accessApi(this.rawApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "projects", {
        get: function () {
            return sdkCore.accessApi(this.projectsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "groups", {
        get: function () {
            return sdkCore.accessApi(this.groupsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "securityCategories", {
        get: function () {
            return sdkCore.accessApi(this.securityCategoriesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "serviceAccounts", {
        get: function () {
            return sdkCore.accessApi(this.serviceAccountsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "models3D", {
        get: function () {
            return sdkCore.accessApi(this.models3DApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "revisions3D", {
        get: function () {
            return sdkCore.accessApi(this.revisions3DApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "files3D", {
        get: function () {
            return sdkCore.accessApi(this.files3DApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "datasets", {
        get: function () {
            return sdkCore.accessApi(this.datasetsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "assetMappings3D", {
        get: function () {
            return sdkCore.accessApi(this.assetMappings3DApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "viewer3D", {
        get: function () {
            return sdkCore.accessApi(this.viewer3DApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "apiKeys", {
        get: function () {
            return sdkCore.accessApi(this.apiKeysApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "relationships", {
        get: function () {
            return sdkCore.accessApi(this.relationshipsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "entityMatching", {
        get: function () {
            return sdkCore.accessApi(this.entityMatchingApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "geospatial", {
        get: function () {
            return sdkCore.accessApi(this.geospatialApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "documents", {
        get: function () {
            return sdkCore.accessApi(this.documentsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "annotations", {
        get: function () {
            return sdkCore.accessApi(this.annotationsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "vision", {
        get: function () {
            return sdkCore.accessApi(this.visionApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "profiles", {
        get: function () {
            return sdkCore.accessApi(this.profilesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "sessions", {
        get: function () {
            return sdkCore.accessApi(this.sessionsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "templates", {
        get: function () {
            var _this = this;
            return {
                groups: sdkCore.accessApi(this.apiFactory(TemplateGroupsApi, 'templategroups')),
                group: function (externalId) {
                    var urlsafeExternalId = CogniteClient.urlEncodeExternalId(externalId);
                    var baseVersionsUrl = "templategroups/" + urlsafeExternalId + "/versions";
                    return {
                        versions: sdkCore.accessApi(_this.apiFactory(TemplateGroupVersionsApi, baseVersionsUrl)),
                        version: function (version) {
                            var baseGroupUrl = baseVersionsUrl + "/" + version;
                            var graphQlApi = _this.apiFactory(TemplateGraphQlApi, baseGroupUrl + "/graphql");
                            return {
                                instances: sdkCore.accessApi(_this.apiFactory(TemplateInstancesApi, baseGroupUrl + "/instances")),
                                runQuery: function (graphQlParams) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                    return [2 /*return*/, graphQlApi.runQuery(graphQlParams)];
                                }); }); },
                                views: sdkCore.accessApi(_this.apiFactory(ViewsApi, baseGroupUrl + "/views")),
                            };
                        },
                    };
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "units", {
        get: function () {
            return sdkCore.accessApi(this.unitsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "instances", {
        get: function () {
            return sdkCore.accessApi(this.instancesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "containers", {
        get: function () {
            return sdkCore.accessApi(this.containersApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "views", {
        get: function () {
            return sdkCore.accessApi(this.viewsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "spaces", {
        get: function () {
            return sdkCore.accessApi(this.spacesApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "dataModels", {
        get: function () {
            return sdkCore.accessApi(this.dataModelsApi);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CogniteClient.prototype, "version", {
        get: function () {
            return version;
        },
        enumerable: false,
        configurable: true
    });
    CogniteClient.prototype.getRetryValidator = function () {
        return retryValidator;
    };
    CogniteClient.prototype.initAPIs = function () {
        var models3DPath = '3d/models';
        // Lock version to the following date
        this.httpClient.setDefaultHeader('cdf-version', 'V20210406');
        this.assetsApi = this.apiFactory(AssetsAPI, 'assets');
        this.timeSeriesApi = this.apiFactory(TimeSeriesAPI, 'timeseries');
        this.dataPointsApi = this.apiFactory(DataPointsAPI, 'timeseries/data');
        this.sequencesApi = this.apiFactory(SequencesAPI, 'sequences');
        this.eventsApi = this.apiFactory(EventsAPI, 'events');
        this.filesApi = this.apiFactory(FilesAPI, 'files');
        this.labelsApi = this.apiFactory(LabelsAPI, 'labels');
        this.datasetsApi = this.apiFactory(DataSetsAPI, 'datasets');
        this.rawApi = this.apiFactory(RawAPI, 'raw/dbs');
        this.groupsApi = this.apiFactory(GroupsAPI, 'groups');
        this.securityCategoriesApi = this.apiFactory(SecurityCategoriesAPI, 'securitycategories');
        this.serviceAccountsApi = this.apiFactory(ServiceAccountsAPI, 'serviceaccounts');
        this.apiKeysApi = this.apiFactory(ApiKeysAPI, 'apikeys');
        this.models3DApi = this.apiFactory(Models3DAPI, models3DPath);
        this.relationshipsApi = this.apiFactory(RelationshipsApi, 'relationships');
        this.entityMatchingApi = this.apiFactory(EntityMatchingApi, 'context/entitymatching');
        this.revisions3DApi = this.apiFactory(Revisions3DAPI, models3DPath);
        this.files3DApi = this.apiFactory(Files3DAPI, '3d/files');
        this.assetMappings3DApi = this.apiFactory(AssetMappings3DAPI, models3DPath);
        this.viewer3DApi = this.apiFactory(Viewer3DAPI, '3d');
        this.projectsApi = new ProjectsAPI(sdkCore.apiUrl(), this.httpClient, this.metadataMap);
        this.geospatialApi = this.apiFactory(GeospatialAPI, 'geospatial');
        this.documentsApi = this.apiFactory(DocumentsAPI, 'documents');
        this.annotationsApi = this.apiFactory(AnnotationsAPI, 'annotations');
        this.visionApi = this.apiFactory(VisionAPI, 'context/vision');
        this.profilesApi = this.apiFactory(ProfilesAPI, 'profiles');
        this.unitsApi = this.apiFactory(UnitsAPI, 'units');
        this.instancesApi = this.apiFactory(InstancesAPI, 'models/instances');
        this.containersApi = this.apiFactory(ContainersAPI, 'models/containers');
        this.viewsApi = this.apiFactory(ViewsAPI, 'models/views');
        this.spacesApi = this.apiFactory(SpacesAPI, 'models/spaces');
        this.dataModelsApi = this.apiFactory(DataModelsAPI, 'models/datamodels');
        this.sessionsApi = this.apiFactory(SessionsApi, 'sessions');
    };
    CogniteClient.urlEncodeExternalId = function (externalId) {
        return encodeURIComponent(externalId);
    };
    return CogniteClient;
}(sdkCore.BaseCogniteClient));

Object.defineProperty(exports, 'CogniteAuthentication', {
    enumerable: true,
    get: function () {
        return sdkCore.CogniteAuthentication;
    }
});
Object.defineProperty(exports, 'CogniteError', {
    enumerable: true,
    get: function () {
        return sdkCore.CogniteError;
    }
});
Object.defineProperty(exports, 'CogniteLoginError', {
    enumerable: true,
    get: function () {
        return sdkCore.CogniteLoginError;
    }
});
Object.defineProperty(exports, 'CogniteMultiError', {
    enumerable: true,
    get: function () {
        return sdkCore.CogniteMultiError;
    }
});
Object.defineProperty(exports, 'HttpError', {
    enumerable: true,
    get: function () {
        return sdkCore.HttpError;
    }
});
Object.defineProperty(exports, 'HttpResponseType', {
    enumerable: true,
    get: function () {
        return sdkCore.HttpResponseType;
    }
});
Object.defineProperty(exports, 'POPUP', {
    enumerable: true,
    get: function () {
        return sdkCore.POPUP;
    }
});
Object.defineProperty(exports, 'REDIRECT', {
    enumerable: true,
    get: function () {
        return sdkCore.REDIRECT;
    }
});
Object.defineProperty(exports, 'isLoginPopupWindow', {
    enumerable: true,
    get: function () {
        return sdkCore.isLoginPopupWindow;
    }
});
Object.defineProperty(exports, 'loginPopupHandler', {
    enumerable: true,
    get: function () {
        return sdkCore.loginPopupHandler;
    }
});
exports.ApiKeysAPI = ApiKeysAPI;
exports.AssetMappings3DAPI = AssetMappings3DAPI;
exports.AssetsAPI = AssetsAPI;
exports.CogniteClient = CogniteClient;
exports.ConstantResolver = ConstantResolver;
exports.ContextJobStatus = ContextJobStatus;
exports.DataPointsAPI = DataPointsAPI;
exports.DataSetsAPI = DataSetsAPI;
exports.EntityMatchingApi = EntityMatchingApi;
exports.EntityMatchingClassifier = EntityMatchingClassifier;
exports.EntityMatchingFeatureType = EntityMatchingFeatureType;
exports.EventsAPI = EventsAPI;
exports.EventsAggregateAPI = EventsAggregateAPI;
exports.Files3DAPI = Files3DAPI;
exports.FilesAPI = FilesAPI;
exports.FilesMultipartUploadSessionAPI = FilesMultipartUploadSessionAPI;
exports.GroupsAPI = GroupsAPI;
exports.LabelsAPI = LabelsAPI;
exports.Models3DAPI = Models3DAPI;
exports.Nodes3DAPI = Nodes3DAPI;
exports.ProjectsAPI = ProjectsAPI;
exports.RawAPI = RawAPI;
exports.RawResolver = RawResolver;
exports.RawRowsAPI = RawRowsAPI;
exports.RawTablesAPI = RawTablesAPI;
exports.RelationshipsApi = RelationshipsApi;
exports.RevealNodes3DAPI = RevealNodes3DAPI;
exports.RevealRevisions3DAPI = RevealRevisions3DAPI;
exports.RevealSectors3DAPI = RevealSectors3DAPI;
exports.Revisions3DAPI = Revisions3DAPI;
exports.SecurityCategoriesAPI = SecurityCategoriesAPI;
exports.SequenceRowsAPI = SequenceRowsAPI;
exports.SequenceValueType = SequenceValueType;
exports.SequencesAPI = SequencesAPI;
exports.ServiceAccountsAPI = ServiceAccountsAPI;
exports.SessionStatus = SessionStatus;
exports.SessionType = SessionType;
exports.SortOrder = SortOrder;
exports.SyntheticTimeSeriesAPI = SyntheticTimeSeriesAPI;
exports.SyntheticTimeSeriesResolver = SyntheticTimeSeriesResolver;
exports.TemplateGraphQlApi = TemplateGraphQlApi;
exports.TemplateGroupVersionsApi = TemplateGroupVersionsApi;
exports.TemplateGroupsApi = TemplateGroupsApi;
exports.TemplateInstancesApi = TemplateInstancesApi;
exports.TimeSeriesAPI = TimeSeriesAPI;
exports.UnrealRevisions3DAPI = UnrealRevisions3DAPI;
exports.ViewResolver = ViewResolver;
exports.Viewer3DAPI = Viewer3DAPI;
exports.ViewsApi = ViewsApi;
exports.isManagedExternallyGroup = isManagedExternallyGroup;
exports.isManagedInCDFGroup = isManagedInCDFGroup;
//# sourceMappingURL=index.js.map
